webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(213),
  /* template */
  __webpack_require__(364),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(218),
  /* template */
  __webpack_require__(381),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(224),
  /* template */
  __webpack_require__(376),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(223),
  /* template */
  __webpack_require__(383),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(25);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return eventing; });


var eventing = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]();

/***/ }),
/* 14 */,
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_d3__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return tip; });


var tip = {
  tipDiv: function tipDiv() {
    var tip = document.querySelectorAll('.tooltips');

    if (tip.length) {
      return __WEBPACK_IMPORTED_MODULE_0_d3__["select"]('.tooltips');
    }

    return __WEBPACK_IMPORTED_MODULE_0_d3__["select"]('body').append('div').attr('class', 'tooltips').style('opacity', 0);
  },

  tipShow: function tipShow(tip, text, event) {
    var x_screen = void 0,
        y_screen = void 0;

    if (event !== undefined) {
      var offset = void 0;

      if (/map/.test(event.target.id)) {
        offset = 38;
      } else if (/snow/.test(event.target.id)) {
        offset = 158;
      } else {
        offset = 138;
      }

      x_screen = event.pageX - 38;
      y_screen = event.pageY - offset;
    } else {
      x_screen = __WEBPACK_IMPORTED_MODULE_0_d3__["event"].pageX - 38;
      y_screen = __WEBPACK_IMPORTED_MODULE_0_d3__["event"].pageY - 38;
    }

    tip.transition().duration(100).style('opacity', .9);

    tip.html(text).style('top', y_screen + 'px').style('left', x_screen + 'px');
  },

  tipHide: function tipHide(tip) {
    tip.transition().duration(500).style('opacity', 0);
  }
};



/***/ }),
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_d3__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return formatting; });


var formatting = {
  stringDate: function stringDate(month, full) {
    var month_names = void 0;

    if (full !== undefined) {
      month_names = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    } else {
      month_names = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    }

    var month_num = parseInt(month, 10) - 1;

    return month_names[month_num];
  },

  fullStateName: function fullStateName(val) {
    var states = {
      AZ: 'Arizona',
      CA: 'California',
      CO: 'Colorado',
      ID: 'Idaho',
      MT: 'Montana',
      NM: 'New Mexico',
      NV: 'Nevada',
      OR: 'Oregon',
      TX: 'Texas',
      UT: 'Utah',
      WA: 'Washington',
      WY: 'Wyoming'
    };

    return states[val];
  },

  mapScaling: function mapScaling(height, width, map, state) {
    var scale = 1,
        mapType = state !== 'none' ? __WEBPACK_IMPORTED_MODULE_0_d3__["geoMercator"]() : __WEBPACK_IMPORTED_MODULE_0_d3__["geoAlbersUsa"](),
        projection = mapType.scale(scale).translate([0, 0]);

    var path = __WEBPACK_IMPORTED_MODULE_0_d3__["geoPath"]().projection(projection);
    var bounds = path.bounds(map);
    scale = .95 / Math.max((bounds[1][0] - bounds[0][0]) / width, (bounds[1][1] - bounds[0][1]) / height);
    var translation = [(width - scale * (bounds[1][0] + bounds[0][0])) / 2, (height - scale * (bounds[1][1] + bounds[0][1])) / 2 + yOffset(state)];

    projection = mapType.scale(scale).translate(translation);
    path = path.projection(projection);

    return { path: path, projection: projection };
  }
};

function yOffset(state) {
  switch (state) {
    case 'CO':
      return -10;
    case 'OR':
      return -30;
    case 'MT':
      return -70;
    case 'WA':
      return -20;
    default:
      return 0;
  }
}



/***/ }),
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(210),
  /* template */
  __webpack_require__(370),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(215),
  /* template */
  __webpack_require__(380),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 198 */,
/* 199 */,
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Main__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Arizona__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Arizona___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Arizona__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_California__ = __webpack_require__(348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_California___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_California__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Colorado__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Colorado___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Colorado__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Idaho__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Idaho___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_Idaho__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Montana__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Montana___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_Montana__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_New_Mexico__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_New_Mexico___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_New_Mexico__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Nevada__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Nevada___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_Nevada__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Oregon__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Oregon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_Oregon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Texas__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Texas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_Texas__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Utah__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Utah___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_Utah__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Washington__ = __webpack_require__(360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Washington___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_Washington__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Wyoming__ = __webpack_require__(361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Wyoming___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_Wyoming__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_About__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_About___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_About__);

















__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',

  base: '/western_water/',

  routes: [{
    name: 'MainMap',
    path: '/',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Main___default.a
  }, {
    name: 'Arizona',
    path: '/arizona',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Arizona___default.a
  }, {
    name: 'California',
    path: '/california',
    component: __WEBPACK_IMPORTED_MODULE_4__components_California___default.a
  }, {
    name: 'Colorado',
    path: '/colorado',
    component: __WEBPACK_IMPORTED_MODULE_5__components_Colorado___default.a
  }, {
    name: 'Idaho',
    path: '/idaho',
    component: __WEBPACK_IMPORTED_MODULE_6__components_Idaho___default.a
  }, {
    name: 'Montana',
    path: '/montana',
    component: __WEBPACK_IMPORTED_MODULE_7__components_Montana___default.a
  }, {
    name: 'Nevada',
    path: '/nevada',
    component: __WEBPACK_IMPORTED_MODULE_9__components_Nevada___default.a
  }, {
    name: 'New Mexico',
    path: '/new_mexico',
    component: __WEBPACK_IMPORTED_MODULE_8__components_New_Mexico___default.a
  }, {
    name: 'Oregon',
    path: '/oregon',
    component: __WEBPACK_IMPORTED_MODULE_10__components_Oregon___default.a
  }, {
    name: 'Texas',
    path: '/texas',
    component: __WEBPACK_IMPORTED_MODULE_11__components_Texas___default.a
  }, {
    name: 'Utah',
    path: '/utah',
    component: __WEBPACK_IMPORTED_MODULE_12__components_Utah___default.a
  }, {
    name: 'Washington',
    path: '/washington',
    component: __WEBPACK_IMPORTED_MODULE_13__components_Washington___default.a
  }, {
    name: 'Wyoming',
    path: '/wyoming',
    component: __WEBPACK_IMPORTED_MODULE_14__components_Wyoming___default.a
  }, {
    path: '/about',
    name: 'About',
    component: __WEBPACK_IMPORTED_MODULE_15__components_About___default.a
  }],

  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  }
}));

/***/ }),
/* 201 */,
/* 202 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 203 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 204 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(343)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(206),
  /* template */
  __webpack_require__(372),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app'
});

/***/ }),
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'about'
});

/***/ }),
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Map_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Map_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Map_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SnowChart_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SnowChart_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__SnowChart_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__StripChart_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__StripChart_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__StripChart_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DroughtMap_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DroughtMap_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__DroughtMap_vue__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Arizona',

  components: {
    arizonaMap: __WEBPACK_IMPORTED_MODULE_0__Map_vue___default.a,
    snowChart: __WEBPACK_IMPORTED_MODULE_1__SnowChart_vue___default.a,
    stripChart: __WEBPACK_IMPORTED_MODULE_2__StripChart_vue___default.a,
    droughtMap: __WEBPACK_IMPORTED_MODULE_3__DroughtMap_vue___default.a
  }
});

/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Map_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Map_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Map_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SnowChart_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SnowChart_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__SnowChart_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__StripChart_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__StripChart_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__StripChart_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DroughtMap_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DroughtMap_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__DroughtMap_vue__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'California',

  components: {
    californiaMap: __WEBPACK_IMPORTED_MODULE_0__Map_vue___default.a,
    snowChart: __WEBPACK_IMPORTED_MODULE_1__SnowChart_vue___default.a,
    stripChart: __WEBPACK_IMPORTED_MODULE_2__StripChart_vue___default.a,
    droughtMap: __WEBPACK_IMPORTED_MODULE_3__DroughtMap_vue___default.a
  }

});

/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_d3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_svg_legend__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utilities_eventing_js__ = __webpack_require__(13);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CircleLegendChart',

  data: function data() {
    return {
      width: '',
      height: '',
      translate: '',
      centerClass: false
    };
  },


  props: {
    dataValues: Array,
    field: String,
    whichType: String
  },

  watch: {
    dataValues: function dataValues(val) {
      this.dataValues = val;
      this.draw();
    }
  },

  methods: {
    circleSizing: function circleSizing() {
      var sizing = void 0;

      if (window.innerWidth < 500) {
        sizing = [1, 6];
      } else {
        sizing = [2, 20];
      }

      return sizing;
    },
    legendOrientation: function legendOrientation() {
      var screen_width = window.innerWidth;
      var orientation = void 0;

      if (screen_width < 1000) {
        orientation = 'vertical';
        this.height = 250;
        this.width = window.innerWidth;
        this.translate = 'translate(0,0)';
      } else {
        orientation = 'horizontal';

        if (this.whichType === 'map') {
          this.width = 500;
          this.centerClass = true;
          this.height = 120;
          this.translate = 'translate(0,0)';
        } else {
          this.width = window.innerWidth;
          this.height = 70;
          this.translate = 'translate(' + (screen_width - 380) / 2 + ',0)';
        }
      }

      return { orientation: orientation };
    },
    chartType: function chartType() {
      var format = void 0,
          spacing = void 0;
      if (this.whichType === 'map') {
        format = ',';
        if (window.innerWidth < 1000) {
          spacing = 25;
        } else {
          spacing = 50;
        }
      } else {
        format = '.01f';
        if (window.innerWidth < 1000) {
          spacing = 25;
        } else {
          spacing = 50;
        };
      }

      return { format: format, spacing: spacing };
    },
    legendCircle: function legendCircle() {
      var _this = this;

      var legend_scales = __WEBPACK_IMPORTED_MODULE_0_d3__["scaleSqrt"]().domain(__WEBPACK_IMPORTED_MODULE_0_d3__["extent"](this.dataValues, function (d) {
        return +d[_this.field];
      })).range(this.circleSizing());
      var configs = this.legendOrientation();
      var chart_format = this.chartType();

      return __WEBPACK_IMPORTED_MODULE_1_d3_svg_legend__["a" /* default */].legendSize().scale(legend_scales).shape('circle').shapePadding(chart_format.spacing).labelOffset(20).labelFormat(__WEBPACK_IMPORTED_MODULE_0_d3__["format"](chart_format.format)).orient(configs.orientation);
    },
    draw: function draw() {
      var svg = __WEBPACK_IMPORTED_MODULE_0_d3__["select"]('#' + this.field);
      var legend_scale = this.legendCircle();

      if (this.whichType !== 'map') {
        setTimeout(function () {
          svg.call(legend_scale);
        }, 500);
      } else {
        svg.call(legend_scale);
      }
    }
  }
});

/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Map_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Map_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Map_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SnowChart_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SnowChart_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__SnowChart_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__StripChart_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__StripChart_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__StripChart_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DroughtMap_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DroughtMap_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__DroughtMap_vue__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Colorado',

  components: {
    coloradoMap: __WEBPACK_IMPORTED_MODULE_0__Map_vue___default.a,
    snowChart: __WEBPACK_IMPORTED_MODULE_1__SnowChart_vue___default.a,
    stripChart: __WEBPACK_IMPORTED_MODULE_2__StripChart_vue___default.a,
    droughtMap: __WEBPACK_IMPORTED_MODULE_3__DroughtMap_vue___default.a
  }

});

/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DroughtLegendChart'
});

/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_d3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_slider_component__ = __webpack_require__(386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_slider_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_slider_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DroughtLegendChart_vue__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DroughtLegendChart_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__DroughtLegendChart_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utilities_tip__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utilities_formatting__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utilities_eventing_js__ = __webpack_require__(13);










/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DroughtMap',

  data: function data() {
    return {
      graph_height: 500 - this.margins().top - this.margins().bottom,
      graph_width: window.innerWidth - this.margins().left - this.margins().right,
      graph_translate: 'translate(' + this.margins().left + ',' + this.margins().top + ')',
      colors: ['#ffffd4', '#fed98e', '#fe9929', '#d95f0e', '#993404'],
      num_circles: __WEBPACK_IMPORTED_MODULE_1_lodash__["range"](0, 5),
      drought_data: [],
      filtered_data: [],
      centers: [],
      projection: {},
      tipDiv: __WEBPACK_IMPORTED_MODULE_4__utilities_tip__["a" /* tip */],
      none: '',
      done: false,
      droughtType: '',
      droughtTypeLower: '',
      slider_data: {
        value: '11/2025',
        width: '80%',
        reverse: true,
        formatter: function formatter(value) {
          var formatting = __WEBPACK_IMPORTED_MODULE_0_d3__["timeFormat"]('%b, %Y');
          var create_date = __WEBPACK_IMPORTED_MODULE_0_d3__["timeParse"]("%m/%Y");
          return formatting(create_date(value));
        },
        style: {
          marginLeft: '10%',
          marginBottom: '1%'
        },
        data: []
      }
    };
  },


  props: {
    mapFile: String,
    centersFile: String,
    dataFile: String
  },

  components: {
    vueSlider: __WEBPACK_IMPORTED_MODULE_2_vue_slider_component___default.a,
    DroughtLegendChart: __WEBPACK_IMPORTED_MODULE_3__DroughtLegendChart_vue___default.a
  },

  methods: {
    margins: function margins() {
      return { top: 25, right: 40, bottom: 0, left: 75 };
    },
    updateSlider: function updateSlider(val) {
      this.filtered_data = this.filteredData(val);
    },
    filteredData: function filteredData(test_value) {
      return this.drought_data.filter(function (d) {
        return d.full_date === test_value;
      });
    },
    whichType: function whichType(d) {
      return d.county !== undefined ? 'county' : 'state';
    },
    whichState: function whichState(values, d) {
      var field = this.whichType(d);

      return __WEBPACK_IMPORTED_MODULE_1_lodash__["find"](values, function (e) {
        return d[field] === e[field];
      });
    },
    findValue: function findValue(d, values, iteration) {
      var state = this.whichState(values, d);
      return state['D' + iteration] * .1;
    },
    formatted: function formatted(value) {
      return value === 100.0 ? 100 : value;
    },
    showItem: function showItem(d, tip, event) {
      var state = this.whichState(this.filtered_data, d);
      var header_field = this.whichType(d);
      var text_formatted = void 0;

      if (header_field === 'county') {
        text_formatted = d[header_field] + ' County';
      } else {
        text_formatted = __WEBPACK_IMPORTED_MODULE_5__utilities_formatting__["a" /* formatting */].fullStateName(d[header_field]);
      }

      var text = '\n        <h4 class="text-center tip">' + text_formatted + '</h4>\n        <h5 class="text-center tip">' + __WEBPACK_IMPORTED_MODULE_5__utilities_formatting__["a" /* formatting */].stringDate(state.month, true) + ', ' + state.year + '</h5>\n         <h5  class="text-center tip">Drought Levels (% of ' + __WEBPACK_IMPORTED_MODULE_1_lodash__["capitalize"](header_field) + ')</h5>\n         <div class="row">\n           <div class="col-md-6">\n             <ul class="list-unstyled first">\n               <li>D0: ' + this.formatted(state['D0']) + '%</li>\n               <li>D1: ' + this.formatted(state['D1']) + '%</li>\n               <li>D2: ' + this.formatted(state['D2']) + '%</li>\n             </ul>\n            </div>\n            <div class="col-md-6">\n              <ul class="list-unstyled last">\n                <li>D3: ' + this.formatted(state['D3']) + '%</li>\n                <li>D4: ' + this.formatted(state['D4']) + '%</li>\n              </ul>\n            </div>\n          </div>';

      tip.tipShow(tip.tipDiv(), text, event);
    },
    hideItem: function hideItem(d, tip, event) {
      tip.tipHide(tip.tipDiv());
    },
    draw: function draw() {
      var vm = this;
      var svg = __WEBPACK_IMPORTED_MODULE_0_d3__["select"]('#drought_map');

      __WEBPACK_IMPORTED_MODULE_0_d3__["queue"]().defer(__WEBPACK_IMPORTED_MODULE_0_d3__["json"], 'static/data/maps/' + this.mapFile).defer(__WEBPACK_IMPORTED_MODULE_0_d3__["json"], 'static/data/drought/centers/' + this.centersFile).defer(__WEBPACK_IMPORTED_MODULE_0_d3__["csv"], 'static/data/drought/' + this.dataFile).await(function (error, map, centers, data) {
        data.forEach(function (d) {
          d.full_date = d.month + '/' + d.year;
        });

        vm.droughtTypeLower = vm.whichType(data[0]);
        vm.droughtType = __WEBPACK_IMPORTED_MODULE_1_lodash__["capitalize"](vm.whichType(data[0]));
        vm.drought_data = data;
        vm.slider_data.data = __WEBPACK_IMPORTED_MODULE_1_lodash__["pluck"](__WEBPACK_IMPORTED_MODULE_1_lodash__["uniq"](vm.drought_data, 'full_date'), 'full_date').reverse();

        var test_value = __WEBPACK_IMPORTED_MODULE_1_lodash__["last"](vm.drought_data).full_date;
        vm.filtered_data = vm.filteredData(test_value);
        vm.centers = centers;

        var map_path = __WEBPACK_IMPORTED_MODULE_5__utilities_formatting__["a" /* formatting */].mapScaling(vm.graph_height, vm.graph_width, map);
        vm.projection = map_path.projection;

        var path = map_path.path;
        var maps = svg.selectAll('path').data(map.features);

        maps.enter().append('path').merge(maps).attr('vector-effect', 'non-scaling-stroke').attr('d', path);

        maps.exit().remove();
      });

      __WEBPACK_IMPORTED_MODULE_6__utilities_eventing_js__["a" /* eventing */].$on('is-done', function (done) {
        vm.done = done;
      });
    }
  },

  mounted: function mounted() {
    this.draw();
  }
});

/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Map_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Map_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Map_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SnowChart_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SnowChart_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__SnowChart_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__StripChart_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__StripChart_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__StripChart_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DroughtMap_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DroughtMap_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__DroughtMap_vue__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Idaho',

  components: {
    idahoMap: __WEBPACK_IMPORTED_MODULE_0__Map_vue___default.a,
    snowChart: __WEBPACK_IMPORTED_MODULE_1__SnowChart_vue___default.a,
    stripChart: __WEBPACK_IMPORTED_MODULE_2__StripChart_vue___default.a,
    droughtMap: __WEBPACK_IMPORTED_MODULE_3__DroughtMap_vue___default.a
  }

});

/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_d3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_svg_legend__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utilities_eventing_js__ = __webpack_require__(13);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'LegendChart',

  data: function data() {
    return {
      width: '',
      height: '',
      translate: '',
      done: false
    };
  },


  props: {
    colors: Array,
    dataValues: Array,
    field: String
  },

  watch: {
    dataValues: function dataValues(val) {
      this.dataValues = val;
      this.draw();
    }
  },

  methods: {
    legendOrientation: function legendOrientation() {
      var screen_width = window.innerWidth;
      var size = void 0,
          orientation = void 0;

      if (screen_width < 1100) {
        size = 40;
        orientation = 'vertical';
        this.height = 210;
        this.width = 200;
        this.translate = 'translate(0,0)';
      } else {
        size = 80;
        orientation = 'horizontal';
        this.height = 90;
        this.width = 1100;
        this.translate = 'translate(' + (screen_width - 930) / 2 + ',20)';
      }

      return { size: size, orientation: orientation };
    },
    legendSquare: function legendSquare() {
      var field_name = this.field.split('-')[0];
      var legend_scales = __WEBPACK_IMPORTED_MODULE_0_d3__["scaleQuantile"]().domain(__WEBPACK_IMPORTED_MODULE_0_d3__["extent"](this.dataValues, function (d) {
        return +d[field_name];
      })).range(this.colors);
      var configs = this.legendOrientation();

      return __WEBPACK_IMPORTED_MODULE_1_d3_svg_legend__["a" /* default */].legendColor().shapeWidth(configs.size).orient(configs.orientation).labelFormat(__WEBPACK_IMPORTED_MODULE_0_d3__["format"]('.01f')).scale(legend_scales);
    },
    draw: function draw() {
      var svg = __WEBPACK_IMPORTED_MODULE_0_d3__["select"]('#' + this.field);
      var legend_scale = this.legendSquare();

      setTimeout(function () {
        svg.call(legend_scale);
      }, 500);
    }
  }
});

/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_d3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utilities_formatting__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utilities_tip__ = __webpack_require__(15);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'LineChart',

  data: function data() {
    return {
      location: '',
      res_avg: '',
      storage: '',
      avg_storage: '',

      graph_height: 500 - this.margins().top - this.margins().bottom,
      graph_width: 650 - this.margins().left - this.margins().right,
      graph_translate: 'translate(' + this.margins().left + ',' + this.margins().top + ')'
    };
  },


  props: {
    selectedData: Array,
    hasKey: Boolean,
    reservoirName: String,
    whichState: String
  },

  watch: {
    selectedData: function selectedData(val) {
      this.selectedData = val;
      this.draw();
    },

    reservoirName: function reservoirName(val) {
      this.reservoirName = val;
    }
  },

  methods: {
    margins: function margins() {
      return { top: 20, right: 130, left: 100, bottom: 80 };
    },
    histAvg: function histAvg(data) {
      if (data[0].mean === undefined) {
        var avg = __WEBPACK_IMPORTED_MODULE_0_d3__["mean"](data, function (d) {
          if (d.storage !== undefined) {
            return +d.storage;
          } else {
            return +d.value;
          }
        });

        data.forEach(function (d) {
          d.mean = avg;
        });
      }

      return data;
    },
    stateName: function stateName(d) {
      return this.whichState === 'none' ? d.state.toUpperCase() : this.whichState;
    },
    linePath: function linePath(field, formatting, scales) {
      return __WEBPACK_IMPORTED_MODULE_0_d3__["line"]().curve(__WEBPACK_IMPORTED_MODULE_0_d3__["curveNatural"]).x(function (d) {
        return scales.xScale(formatting(d.date));
      }).y(function (d) {
        return scales.yScale(d[field]);
      });
    },
    draw: function draw() {
      var data = this.histAvg(this.selectedData),
          format = __WEBPACK_IMPORTED_MODULE_0_d3__["timeParse"]('%m/%Y'),
          margin = this.margins(),
          num_format = __WEBPACK_IMPORTED_MODULE_0_d3__["format"](',');

      var tip_div = __WEBPACK_IMPORTED_MODULE_3__utilities_tip__["a" /* tip */].tipDiv();
      var xScale = __WEBPACK_IMPORTED_MODULE_0_d3__["scaleTime"]().domain(__WEBPACK_IMPORTED_MODULE_0_d3__["extent"](data, function (d) {
        return format(d.date);
      }));

      xScale.range([0, this.graph_width]);

      var yScale = __WEBPACK_IMPORTED_MODULE_0_d3__["scaleLinear"]().domain([__WEBPACK_IMPORTED_MODULE_0_d3__["max"](data, function (d) {
        return d.capacity;
      }) * 1.2, 0]);

      yScale.range([0, this.graph_height]);

      var scales = { xScale: xScale, yScale: yScale };

      var bisectDate = __WEBPACK_IMPORTED_MODULE_0_d3__["bisector"](function (d) {
        return format(d.date);
      }).right;

      var xAxis = __WEBPACK_IMPORTED_MODULE_0_d3__["axisBottom"]().scale(xScale);

      var yAxis = __WEBPACK_IMPORTED_MODULE_0_d3__["axisLeft"]().scale(yScale);

      this.location = this.reservoirName + ', ' + this.stateName(data[0]);
      this.res_avg = num_format(__WEBPACK_IMPORTED_MODULE_1_lodash__["round"](+data[0].mean, 1));

      var storage = this.linePath('storage', format, scales);
      var avg_storage = this.linePath('mean', format, scales);


      __WEBPACK_IMPORTED_MODULE_0_d3__["select"]('#line-chart').attr('width', this.graph_width + margin.left + margin.right).attr('height', this.graph_height + margin.top + margin.bottom);

      __WEBPACK_IMPORTED_MODULE_0_d3__["select"]('#line-chart g.x').transition().duration(1000).ease(__WEBPACK_IMPORTED_MODULE_0_d3__["easeSinInOut"]).call(xAxis);

      __WEBPACK_IMPORTED_MODULE_0_d3__["select"]('#line-chart g.y').transition().duration(1000).ease(__WEBPACK_IMPORTED_MODULE_0_d3__["easeSinInOut"]).call(yAxis);

      __WEBPACK_IMPORTED_MODULE_0_d3__["select"]('#storage').transition().duration(1000).ease(__WEBPACK_IMPORTED_MODULE_0_d3__["easeSinInOut"]).attr('d', storage(data));

      __WEBPACK_IMPORTED_MODULE_0_d3__["select"]('#avg_storage').transition().duration(1200).ease(__WEBPACK_IMPORTED_MODULE_0_d3__["easeSinInOut"]).attr('d', avg_storage(data));

      var focus = __WEBPACK_IMPORTED_MODULE_0_d3__["select"]('.focus');
      __WEBPACK_IMPORTED_MODULE_0_d3__["select"]('rect.overlay').on('mouseover touchstart', function () {
        focus.style('display', null);
      }).on('mouseout touchend', function () {
        focus.style('display', 'none');
        __WEBPACK_IMPORTED_MODULE_3__utilities_tip__["a" /* tip */].tipHide(tip_div);
      }).on('mousemove touchmove', mousemove).attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');

      function mousemove() {
        var x0 = xScale.invert(__WEBPACK_IMPORTED_MODULE_0_d3__["mouse"](this)[0]),
            i = bisectDate(data, x0, 1),
            d0 = data[i - 1],
            d1 = data[i];

        if (d1 === undefined) d1 = Infinity;
        var d = x0 - d0.date > d1.date - x0 ? d1 : d0;
        __WEBPACK_IMPORTED_MODULE_0_d3__["select"]('#graph line.y0').attr('transform', 'translate(' + (xScale(format(d.date)) + margin.left) + ',' + margin.top + ')');

        var date_bits = d.date.split('/');
        var message = '<h4 class=\'text-center tip\'>' + __WEBPACK_IMPORTED_MODULE_2__utilities_formatting__["a" /* formatting */].stringDate(date_bits[0]) + ', ' + date_bits[1] + '</h4>\n        <ul class=\'list-unstyled\'>\n        <li>Capacity: ' + num_format(d.capacity) + ' acre ft</li>\n        <li>Vol: ' + num_format(d.storage) + ' acre ft</li>\n        <li>Pct Full: ' + d.pct_capacity + '%</li>\n        <li>Pct of Hist. Avg: ' + (d.storage / d.mean * 100).toFixed(1) + '%</li>\n        </ul>';

        __WEBPACK_IMPORTED_MODULE_3__utilities_tip__["a" /* tip */].tipShow(tip_div, message);
      }
    }
  }
});

/***/ }),
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Map_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Map_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Map_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SnowChart_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SnowChart_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__SnowChart_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__StripChart_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__StripChart_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__StripChart_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DroughtMap_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DroughtMap_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__DroughtMap_vue__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Main',

  components: {
    mainMap: __WEBPACK_IMPORTED_MODULE_0__Map_vue___default.a,
    snowChart: __WEBPACK_IMPORTED_MODULE_1__SnowChart_vue___default.a,
    stripChart: __WEBPACK_IMPORTED_MODULE_2__StripChart_vue___default.a,
    droughtMap: __WEBPACK_IMPORTED_MODULE_3__DroughtMap_vue___default.a
  },

  data: function data() {
    return {
      hasKey: true
    };
  }
});

/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_d3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__LineChart_vue__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__LineChart_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__LineChart_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CircleLegendChart_vue__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CircleLegendChart_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__CircleLegendChart_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utilities_tip__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utilities_stations__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utilities_formatting__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utilities_eventing_js__ = __webpack_require__(13);












/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Map',

  data: function data() {
    return {
      loading: true,
      done: false,
      map: [],
      data: [],
      stations: [],
      resValue: this.res,
      fullState: __WEBPACK_IMPORTED_MODULE_7__utilities_formatting__["a" /* formatting */].fullStateName(this.whichState),
      height: this.baseHeight(),
      width: this.baseWidth(),
      loadOffset: window.innerWidth < 1080,
      scale: {},
      projection: {},
      tipDiv: __WEBPACK_IMPORTED_MODULE_5__utilities_tip__["a" /* tip */],
      whichType: 'map',
      legend_field: 'capacity',
      stateCode: this.whichState,
      offset: this.hasKey || this.whichState === 'TX' ? 'translate(10,0)' : 'translate(35,0)'
    };
  },


  props: {
    dataFile: String,
    mapFile: String,
    res: String,
    resFile: String,
    hasKey: Boolean,
    selectedData: Array,
    reservoirName: String,
    whichState: String
  },

  components: {
    LineChart: __WEBPACK_IMPORTED_MODULE_3__LineChart_vue___default.a,
    CircleLegendChart: __WEBPACK_IMPORTED_MODULE_4__CircleLegendChart_vue___default.a
  },

  computed: {
    selectedData: function selectedData() {
      return this.data;
    },

    reservoirName: function reservoirName() {
      return this.resValue;
    },

    dateListing: function dateListing() {
      var current_date = __WEBPACK_IMPORTED_MODULE_2_moment___default()().subtract(1, 'month');
      return current_date.format('MMMM YYYY');
    }
  },

  methods: {
    baseHeight: function baseHeight() {
      switch (this.whichState) {
        case 'AZ':
        case 'NV':
        case 'ID':
          return 500;
        case 'CA':
          return 600;
        case 'CO':
          return 440;
        case 'MT':
          return 500;
        case 'NM':
          return 550;
        case 'OR':
          return 430;
        case 'TX':
          return 520;
        case 'UT':
          return 600;
        case 'WA':
          return 430;
        case 'WY':
          return 430;
        default:
          return 420;
      }
    },
    baseWidth: function baseWidth() {
      var width = void 0;

      if (window.innerWidth > 1000 || window.innerWidth < 500) {
        width = window.innerWidth / 2 - 20;
      } else {
        width = 700;
      }

      return width;
    },
    newRes: function newRes(d) {
      var _this = this;

      this.resValue = d.reservoir;

      var selected_file = __WEBPACK_IMPORTED_MODULE_6__utilities_stations__["a" /* reservoirs */].mapped[this.resValue];

      if (selected_file !== undefined) {
        __WEBPACK_IMPORTED_MODULE_0_d3__["csv"]('static/data/states_all/res/' + selected_file, function (d) {
          _this.data = d;
        });
      }
    },
    showItem: function showItem(d, tip, event) {
      __WEBPACK_IMPORTED_MODULE_0_d3__["select"](event.target).attr('r', this.scale(d.capacity) * 1.5);
      tip.tipShow(tip.tipDiv(), d.reservoir, event);
    },
    hideItem: function hideItem(d, tip, event) {
      __WEBPACK_IMPORTED_MODULE_0_d3__["select"](event.target).attr('r', this.scale(d.capacity));
      tip.tipHide(tip.tipDiv());
    },
    mapScale: function mapScale(data) {
      return __WEBPACK_IMPORTED_MODULE_0_d3__["scaleSqrt"]().domain(__WEBPACK_IMPORTED_MODULE_0_d3__["extent"](data, function (d) {
        return d.capacity * .2;
      })).range([3, 13]);
    },
    draw: function draw() {
      var vm = this;
      var svg = __WEBPACK_IMPORTED_MODULE_0_d3__["select"]('#map g');

      __WEBPACK_IMPORTED_MODULE_0_d3__["queue"]().defer(__WEBPACK_IMPORTED_MODULE_0_d3__["json"], 'static/data/maps/' + this.mapFile).defer(__WEBPACK_IMPORTED_MODULE_0_d3__["json"], 'static/data/stations_enhanced/' + this.resFile).defer(__WEBPACK_IMPORTED_MODULE_0_d3__["csv"], 'static/data/states_all/' + this.dataFile).await(function (error, map, stations, data) {
        vm.map = map;
        vm.data = data;

        var zoom = __WEBPACK_IMPORTED_MODULE_0_d3__["zoom"]().scaleExtent([1, 5]).on("zoom", zoomed);
        svg.call(zoom);

        var map_path = __WEBPACK_IMPORTED_MODULE_7__utilities_formatting__["a" /* formatting */].mapScaling(vm.height, vm.width, map, vm.stateCode);
        var path = map_path.path;

        var maps = svg.selectAll('path').data(vm.map.features).call(zoom);

        maps.enter().append('path').merge(maps).attr('vector-effect', 'non-scaling-stroke').attr('d', path);

        maps.exit().remove();

        vm.scale = vm.mapScale(stations);
        vm.stations = stations;
        vm.projection = map_path.projection;

        function zoomed() {
          svg.attr("transform", __WEBPACK_IMPORTED_MODULE_0_d3__["event"].transform);
        }

        vm.loading = false;
        vm.done = true;

        __WEBPACK_IMPORTED_MODULE_8__utilities_eventing_js__["a" /* eventing */].$emit('is-done', true);
      });
    }
  },

  mounted: function mounted() {
    this.draw();
  }
});

/***/ }),
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Map_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Map_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Map_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SnowChart_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SnowChart_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__SnowChart_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__StripChart_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__StripChart_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__StripChart_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DroughtMap_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DroughtMap_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__DroughtMap_vue__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Montana',

  components: {
    montanaMap: __WEBPACK_IMPORTED_MODULE_0__Map_vue___default.a,
    snowChart: __WEBPACK_IMPORTED_MODULE_1__SnowChart_vue___default.a,
    stripChart: __WEBPACK_IMPORTED_MODULE_2__StripChart_vue___default.a,
    droughtMap: __WEBPACK_IMPORTED_MODULE_3__DroughtMap_vue___default.a
  }

});

/***/ }),
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Map_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Map_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Map_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SnowChart_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SnowChart_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__SnowChart_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__StripChart_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__StripChart_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__StripChart_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DroughtMap_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DroughtMap_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__DroughtMap_vue__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Nevada',

  components: {
    nevadaMap: __WEBPACK_IMPORTED_MODULE_0__Map_vue___default.a,
    snowChart: __WEBPACK_IMPORTED_MODULE_1__SnowChart_vue___default.a,
    stripChart: __WEBPACK_IMPORTED_MODULE_2__StripChart_vue___default.a,
    droughtMap: __WEBPACK_IMPORTED_MODULE_3__DroughtMap_vue___default.a
  }

});

/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Map_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Map_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Map_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SnowChart_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SnowChart_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__SnowChart_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__StripChart_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__StripChart_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__StripChart_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DroughtMap_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DroughtMap_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__DroughtMap_vue__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'New_Mexico',

  components: {
    nmMap: __WEBPACK_IMPORTED_MODULE_0__Map_vue___default.a,
    snowChart: __WEBPACK_IMPORTED_MODULE_1__SnowChart_vue___default.a,
    stripChart: __WEBPACK_IMPORTED_MODULE_2__StripChart_vue___default.a,
    droughtMap: __WEBPACK_IMPORTED_MODULE_3__DroughtMap_vue___default.a
  }

});

/***/ }),
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Map_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Map_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Map_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SnowChart_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SnowChart_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__SnowChart_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__StripChart_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__StripChart_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__StripChart_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DroughtMap_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DroughtMap_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__DroughtMap_vue__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Oregon',

  components: {
    oregonMap: __WEBPACK_IMPORTED_MODULE_0__Map_vue___default.a,
    snowChart: __WEBPACK_IMPORTED_MODULE_1__SnowChart_vue___default.a,
    stripChart: __WEBPACK_IMPORTED_MODULE_2__StripChart_vue___default.a,
    droughtMap: __WEBPACK_IMPORTED_MODULE_3__DroughtMap_vue___default.a
  }

});

/***/ }),
/* 223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_d3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LegendChart_vue__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LegendChart_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__LegendChart_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CircleLegendChart_vue__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CircleLegendChart_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__CircleLegendChart_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utilities_tip__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utilities_eventing_js__ = __webpack_require__(13);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SnowChart',

  data: function data() {
    return {
      snow_data: [],
      graph_height: this.baseHeight() - this.margins().top - this.margins().bottom,
      graph_width: this.fullWidth(),
      graph_translate: 'translate(' + this.margins().left + ',' + this.margins().top + ')',
      graph_translate_left: 'translate(' + (this.margins().left - 25) + ',' + this.margins().top + ')',
      tipDiv: __WEBPACK_IMPORTED_MODULE_4__utilities_tip__["a" /* tip */],
      colors: ['#a50026', '#d73027', '#f46d43', '#fdae61', '#fee090', '#ffffbf', '#e0f3f8', '#abd9e9', '#74add1', '#4575b4', '#313695'].reverse(),
      circleSize: {},
      color: {},
      xYearScale: {},
      elevationScale: {},
      numFormat: this.numFormatting(),
      whichType: 'snow',
      done: false,
      legend_temp: 'temp_mean',
      legend_snow: 'snow_mean'
    };
  },


  props: {
    whichState: String,
    dataValues: Array
  },

  computed: {
    dataValues: function dataValues() {
      return this.snow_data;
    }
  },

  components: {
    LegendChart: __WEBPACK_IMPORTED_MODULE_2__LegendChart_vue___default.a,
    CircleLegendChart: __WEBPACK_IMPORTED_MODULE_3__CircleLegendChart_vue___default.a
  },

  methods: {
    margins: function margins() {
      return { top: 25, right: 0, bottom: 0, left: 75 };
    },
    fullWidth: function fullWidth() {
      return window.innerWidth - 50;
    },
    baseHeight: function baseHeight() {
      switch (this.whichState) {
        case 'AZ':
          return 220;
        case 'CA':
          return 280;
        case 'CO':
          return 210;
        case 'ID':
          return 350;
        case 'MT':
          return 320;
        case 'NV':
          return 280;
        case 'NM':
          return 200;
        case 'OR':
          return 300;
        case 'UT':
          return 330;
        case 'WA':
          return 270;
        case 'WY':
          return 320;
        default:
          return 520;
      }
    },
    colorScale: function colorScale(data) {
      return __WEBPACK_IMPORTED_MODULE_0_d3__["scaleQuantile"]().domain(__WEBPACK_IMPORTED_MODULE_0_d3__["extent"](data, function (d) {
        return d.temp_mean;
      })).range(this.colors);
    },
    circleRadius: function circleRadius(data, sizing) {
      return __WEBPACK_IMPORTED_MODULE_0_d3__["scaleSqrt"]().domain(__WEBPACK_IMPORTED_MODULE_0_d3__["extent"](data, function (d) {
        return d.snow_mean;
      })).range(sizing);
    },
    timeScale: function timeScale(data, field, size) {
      var scale = __WEBPACK_IMPORTED_MODULE_0_d3__["scaleTime"]().range([0, size]);
      scale.domain(__WEBPACK_IMPORTED_MODULE_0_d3__["extent"](data, function (d) {
        return d[field];
      }));

      return scale;
    },
    ordinalScale: function ordinalScale(data, size) {
      var scale = __WEBPACK_IMPORTED_MODULE_0_d3__["scaleBand"]().rangeRound([size, 0]).padding(1);

      scale.domain(data);

      return scale;
    },
    showItem: function showItem(d, tip, event) {
      var text = '<h4 class="text-center tip">' + d.date.getFullYear() + '</h4>\n                 <h5  class="text-center tip">Snow/Water Equivalence</h5>\n                 <ul class="list-unstyled">\n                 <li>Elevation: ' + this.numFormat(d.elev) + '+ feet</li>\n                 <li>Temp Mean: ' + d.temp_mean + ' degrees</li>\n                 <li>Water Mean: ' + d.snow_mean + ' inches</li>\n                 <li>Water Median: ' + d.snow_median + ' inches</li>\n                 </ul>';

      __WEBPACK_IMPORTED_MODULE_0_d3__["select"](event.target).attr('r', this.circleSize(d.snow_mean) * 1.3);
      tip.tipShow(tip.tipDiv(), text, event);
    },
    hideItem: function hideItem(d, tip, event) {
      __WEBPACK_IMPORTED_MODULE_0_d3__["select"](event.target).attr('r', this.circleSize(d.snow_mean));
      tip.tipHide(tip.tipDiv());
    },
    numFormatting: function numFormatting() {
      return __WEBPACK_IMPORTED_MODULE_0_d3__["format"](',');
    },
    draw: function draw() {
      var margins = this.margins(),
          parse_year = __WEBPACK_IMPORTED_MODULE_0_d3__["timeParse"]("%Y"),
          full_width = this.fullWidth,
          type = full_width <= 500 ? "%y" : "%Y",
          vm = this,
          sizing = void 0;

      if (full_width < 500) {
        sizing = [1, 6];
      } else {
        sizing = [2, 20];
      }

      __WEBPACK_IMPORTED_MODULE_0_d3__["queue"]().defer(__WEBPACK_IMPORTED_MODULE_0_d3__["csv"], 'static/data/snow/snow_month.csv').await(function (error, datas) {
        var data = datas.filter(function (d) {
          return d.state === vm.whichState;
        });

        data.forEach(function (d) {
          d.date = parse_year(d.year);
          d.snow_mean = +d.snow_mean;
          d.temp_mean = +d.temp_mean;
          d.elev = d.elev + '000';
        });

        var elevations = __WEBPACK_IMPORTED_MODULE_1_lodash__["pluck"](__WEBPACK_IMPORTED_MODULE_1_lodash__["uniq"](data, 'elev'), 'elev');
        elevations.sort(function (a, b) {
          return parseInt(a) - parseInt(b);
        });

        vm.snow_data = data;
        vm.circleSize = vm.circleRadius(data, sizing);
        vm.color = vm.colorScale(data);
        vm.xYearScale = vm.timeScale(data, 'date', vm.fullWidth() - 50 - margins.left - margins.right);
        vm.elevationScale = vm.ordinalScale(elevations, elevations.length * 45);

        var xYearAxis = __WEBPACK_IMPORTED_MODULE_0_d3__["axisTop"]().scale(vm.xYearScale).tickFormat(__WEBPACK_IMPORTED_MODULE_0_d3__["timeFormat"](type));

        var yYearAxis = __WEBPACK_IMPORTED_MODULE_0_d3__["axisLeft"]().scale(vm.elevationScale).tickFormat(__WEBPACK_IMPORTED_MODULE_0_d3__["format"](',d'));

        __WEBPACK_IMPORTED_MODULE_0_d3__["select"]("#snow g.x").call(xYearAxis);
        __WEBPACK_IMPORTED_MODULE_0_d3__["select"]('#snow g.y').call(yYearAxis);
      });

      __WEBPACK_IMPORTED_MODULE_5__utilities_eventing_js__["a" /* eventing */].$on('is-done', function (done) {
        vm.done = done;
      });
    }
  },

  mounted: function mounted() {
    this.draw();
  }
});

/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_d3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LegendChart_vue__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LegendChart_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__LegendChart_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utilities_tip__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utilities_eventing_js__ = __webpack_require__(13);








var margins = { top: 20, right: 50, left: 75, bottom: 75 };

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'StripChart',

  data: function data() {
    return {
      data: [],
      height: 80,
      width: window.innerWidth - 100 - margins.left - margins.right,
      width_large: window.innerWidth - 100 + margins.left + margins.right,
      offset: 'translate(' + margins.left + ',0)',
      scale: {},
      colors: this.colorList(),
      stripColor: {},
      barWidth: '',
      avgVals: [],
      tipDiv: __WEBPACK_IMPORTED_MODULE_3__utilities_tip__["a" /* tip */],
      done: false,
      legend_field: 'anomaly-' + this.stripType,
      areaType: /munged/.test(this.stateFile) ? 'Region' : 'State'
    };
  },


  props: {
    stateFile: String,
    dataValues: Array,
    stripType: String
  },

  computed: {
    dataValues: function dataValues() {
      return this.data;
    }
  },

  components: {
    LegendChart: __WEBPACK_IMPORTED_MODULE_2__LegendChart_vue___default.a
  },

  methods: {
    colorList: function colorList() {
      var colors = void 0;

      if (this.stripType === 'precip' || this.stripType === 'drought') {
        colors = ['#543005', '#8c510a', '#bf812d', '#dfc27d', '#f6e8c3', '#f5f5f5', '#c7eae5', '#80cdc1', '#35978f', '#01665e', '#003c30'];
      } else {
        colors = ['#a50026', '#d73027', '#f46d43', '#fdae61', '#fee090', '#ffffbf', '#e0f3f8', '#abd9e9', '#74add1', '#4575b4', '#313695'].reverse();
      }

      return colors;
    },
    xScale: function xScale() {
      var scale = __WEBPACK_IMPORTED_MODULE_0_d3__["scaleTime"]().range([0, this.width]);
      scale.domain(__WEBPACK_IMPORTED_MODULE_0_d3__["extent"](this.data, function (d) {
        return d.date;
      }));

      return scale;
    },
    showItem: function showItem(data, tip, event) {
      var formatting = __WEBPACK_IMPORTED_MODULE_0_d3__["format"]('.01f');
      __WEBPACK_IMPORTED_MODULE_0_d3__["select"](event.target).attr('height', 100);

      var template = '\n              <h4 class="text-center tip">' + this.stringDate(data.month) + ', ' + data.year + '</h4>\n              <ul class="list-unstyled"\n                <li>Historical Avg: ' + this.monthAvg(this.avgVals, 'drought', data.month) + '</li>\n                <li>Actual Avg: ' + formatting(data.value) + '</li>\n                <li>Departure from Avg: ' + formatting(data.anomaly) + '</li>\n              </ul>';

      tip.tipShow(tip.tipDiv(), template, event);
    },
    hideItem: function hideItem(tip, event) {
      __WEBPACK_IMPORTED_MODULE_0_d3__["select"](event.target).attr('height', 80);
      tip.tipHide(tip.tipDiv());
    },
    stripColors: function stripColors() {
      return __WEBPACK_IMPORTED_MODULE_0_d3__["scaleQuantile"]().domain(__WEBPACK_IMPORTED_MODULE_0_d3__["extent"](this.data, function (d) {
        return +d.anomaly;
      })).range(this.colors);
    },
    stringDate: function stringDate(month) {
      var month_names = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

      var month_num = parseInt(month, 10) - 1;

      return month_names[month_num];
    },
    avgValues: function avgValues(data) {
      var months = __WEBPACK_IMPORTED_MODULE_0_d3__["range"](1, 13);
      var avgs = {
        drought: []
      };
      var field_value = void 0,
          avg = void 0;

      months.forEach(function (month) {
        var month_format = month < 10 ? '0' + month : '' + month;
        field_value = __WEBPACK_IMPORTED_MODULE_1_lodash__["findWhere"](data, { month: month_format });
        avg = field_value.value - field_value.anomaly;
        avgs['drought'].push({ key: month_format, value: avg });
      });

      return avgs;
    },
    monthAvg: function monthAvg(avgs, field, month) {
      return avgs[field][parseInt(month, 10) - 1].value.toFixed(2);
    },
    barsWidth: function barsWidth() {
      return __WEBPACK_IMPORTED_MODULE_1_lodash__["floor"](this.width / this.data.length, 3);
    },
    draw: function draw() {
      var vm = this;

      __WEBPACK_IMPORTED_MODULE_0_d3__["csv"]('static/data/palmer/' + this.stateFile, function (datas) {
        var parse_date = __WEBPACK_IMPORTED_MODULE_0_d3__["timeParse"]('%m/%Y');

        datas.forEach(function (d) {
          d.date = parse_date(d.month + '/' + d.year);
        });
        var sorted_data = __WEBPACK_IMPORTED_MODULE_1_lodash__["sortByOrder"](datas, ['year', 'month']);

        vm.data = sorted_data;
        vm.scale = vm.xScale();
        vm.stripColor = vm.stripColors();
        vm.barWidth = vm.barsWidth();
        vm.avgVals = vm.avgValues(sorted_data);
        vm.barWidth = vm.barsWidth();
      });

      __WEBPACK_IMPORTED_MODULE_4__utilities_eventing_js__["a" /* eventing */].$on('is-done', function (done) {
        vm.done = done;
      });
    }
  },

  mounted: function mounted() {
    this.draw();
  }
});

/***/ }),
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Map_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Map_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Map_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StripChart_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StripChart_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__StripChart_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DroughtMap_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DroughtMap_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__DroughtMap_vue__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Texas',

  components: {
    texasMap: __WEBPACK_IMPORTED_MODULE_0__Map_vue___default.a,
    stripChart: __WEBPACK_IMPORTED_MODULE_1__StripChart_vue___default.a,
    droughtMap: __WEBPACK_IMPORTED_MODULE_2__DroughtMap_vue___default.a
  }

});

/***/ }),
/* 226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Map_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Map_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Map_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SnowChart_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SnowChart_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__SnowChart_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__StripChart_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__StripChart_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__StripChart_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DroughtMap_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DroughtMap_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__DroughtMap_vue__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Utah',

  components: {
    utahMap: __WEBPACK_IMPORTED_MODULE_0__Map_vue___default.a,
    snowChart: __WEBPACK_IMPORTED_MODULE_1__SnowChart_vue___default.a,
    stripChart: __WEBPACK_IMPORTED_MODULE_2__StripChart_vue___default.a,
    droughtMap: __WEBPACK_IMPORTED_MODULE_3__DroughtMap_vue___default.a
  }

});

/***/ }),
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Map_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Map_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Map_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SnowChart_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SnowChart_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__SnowChart_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__StripChart_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__StripChart_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__StripChart_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DroughtMap_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DroughtMap_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__DroughtMap_vue__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Washington',

  components: {
    washingtonMap: __WEBPACK_IMPORTED_MODULE_0__Map_vue___default.a,
    snowChart: __WEBPACK_IMPORTED_MODULE_1__SnowChart_vue___default.a,
    stripChart: __WEBPACK_IMPORTED_MODULE_2__StripChart_vue___default.a,
    droughtMap: __WEBPACK_IMPORTED_MODULE_3__DroughtMap_vue___default.a
  }

});

/***/ }),
/* 228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Map_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Map_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Map_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SnowChart_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SnowChart_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__SnowChart_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__StripChart_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__StripChart_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__StripChart_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DroughtMap_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DroughtMap_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__DroughtMap_vue__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Wyoming',

  components: {
    wyomingMap: __WEBPACK_IMPORTED_MODULE_0__Map_vue___default.a,
    snowChart: __WEBPACK_IMPORTED_MODULE_1__SnowChart_vue___default.a,
    stripChart: __WEBPACK_IMPORTED_MODULE_2__StripChart_vue___default.a,
    droughtMap: __WEBPACK_IMPORTED_MODULE_3__DroughtMap_vue___default.a
  }

});

/***/ }),
/* 229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return reservoirs; });
var reservoirs = {
  mapped: {
    "Abilene": "abilene.csv",
    "Addicks": "addicks.csv",
    "Alan Henry": "alan-henry.csv",
    "Amistad": "amistad.csv",
    "Amon G Carter": "amon-g-carter.csv",
    "Aquilla": "aquilla.csv",
    "Arlington": "arlington.csv",
    "Arrowhead": "arrowhead.csv",
    "Athens": "athens.csv",
    "Austin": "austin.csv",
    "B A Steinhagen": "b-a-steinhagen.csv",
    "Bardwell": "bardwell.csv",
    "Belton": "belton.csv",
    "Benbrook": "benbrook.csv",
    "Bob Sandlin": "bob-sandlin.csv",
    "Bonham": "bonham.csv",
    "Brady Creek": "brady-creek.csv",
    "Bridgeport": "bridgeport.csv",
    "Brownwood": "brownwood.csv",
    "Buchanan": "buchanan.csv",
    "Caddo": "caddo.csv",
    "Canyon": "canyon.csv",
    "Cedar Creek": "cedar-creek.csv",
    "Champion Creek": "champion-creek.csv",
    "Choke Canyon": "choke-canyon.csv",
    "Cisco": "cisco.csv",
    "Coleman": "coleman.csv",
    "Coleto Creek": "coleto-creek.csv",
    "Colorado City": "colorado-city.csv",
    "Conroe": "conroe.csv",
    "Corpus Christi": "corpus-christi.csv",
    "Crook": "crook.csv",
    "Cypress Springs": "cypress-springs.csv",
    "E V Spence": "e-v-spence.csv",
    "Eagle Mountain": "eagle-mountain.csv",
    "Elephant Butte": "elephant_butte_reservoir.csv",
    "Falcon": "falcon.csv",
    "Fork": "fork.csv",
    "Fort Phantom Hill": "fort-phantom-hill.csv",
    "Georgetown": "georgetown.csv",
    "Graham": "graham.csv",
    "Granbury": "granbury.csv",
    "Granger": "granger.csv",
    "Grapevine": "grapevine.csv",
    "Greenbelt": "greenbelt.csv",
    "Halbert": "halbert.csv",
    "Hords Creek": "hords-creek.csv",
    "Houston County": "houston-county.csv",
    "Houston": "houston.csv",
    "Hubbard Creek": "hubbard-creek.csv",
    "Hubert H Moss": "hubert-h-moss.csv",
    "Inks": "inks.csv",
    "J B Thomas": "j-b-thomas.csv",
    "Jacksonville": "jacksonville.csv",
    "Jim Chapman": "jim-chapman.csv",
    "Joe Pool": "joe-pool.csv",
    "Kemp": "kemp.csv",
    "Kickapoo": "kickapoo.csv",
    "Lake O The Pines": "lake-o-the-pines.csv",
    "Lavon": "lavon.csv",
    "Leon": "leon.csv",
    "Lewisville": "lewisville.csv",
    "Limestone": "limestone.csv",
    "Livingston": "livingston.csv",
    "Lost Creek": "OR_Lost_Creek.csv",
    "Lyndon B Johnson": "lyndon-b-johnson.csv",
    "Mackenzie": "mackenzie.csv",
    "Martin": "martin.csv",
    "Medina": "medina.csv",
    "Meredith": "meredith.csv",
    "Millers Creek": "millers-creek.csv",
    "Mineral Wells": "mineral-wells.csv",
    "Monticello": "monticello.csv",
    "Mountain Creek": "mountain-creek.csv",
    "Murvaul": "murvaul.csv",
    "Nacogdoches": "nacogdoches.csv",
    "Natural Dam": "natural-dam.csv",
    "Navarro Mills": "navarro-mills.csv",
    "New Terrell City": "new-terrell-city.csv",
    "Nocona": "nocona.csv",
    "North Fork Buffalo Creek": "north-fork-buffalo-creek.csv",
    "O C Fisher": "o-c-fisher.csv",
    "O H Ivie": "o-h-ivie.csv",
    "Oak Creek": "oak-creek.csv",
    "Palestine": "palestine.csv",
    "Palo Duro": "palo-duro.csv",
    "Palo Pinto": "palo-pinto.csv",
    "Pat Cleburne": "pat-cleburne.csv",
    "Pat Mayse": "pat-mayse.csv",
    "Possum Kingdom": "possum-kingdom.csv",
    "Proctor": "proctor.csv",
    "Ray Hubbard": "ray-hubbard.csv",
    "Ray Roberts": "ray-roberts.csv",
    "Red Bluff": "red-bluff.csv",
    "Richland Chambers": "richland-chambers.csv",
    "Sam Rayburn": "sam-rayburn.csv",
    "Somerville": "somerville.csv",
    "Squaw Creek": "squaw-creek.csv",
    "Stamford": "stamford.csv",
    "Stillhouse Hollow": "stillhouse-hollow.csv",
    "Sulphur Springs": "sulphur-springs.csv",
    "Sweetwater": "sweetwater.csv",
    "Tawakoni": "tawakoni.csv",
    "Texana": "texana.csv",
    "Texoma": "texoma.csv",
    "Toledo Bend": "toledo-bend.csv",
    "Travis": "travis.csv",
    "Twin Buttes": "twin-buttes.csv",
    "Tyler": "tyler.csv",
    "Waco": "waco.csv",
    "Waxahachie": "waxahachie.csv",
    "Weatherford": "weatherford.csv",
    "White River": "white-river.csv",
    "Whitney": "whitney.csv",
    "Worth": "worth.csv",
    "Wright Patman": "wright-patman.csv",
    "Alpine Lake": "alpine_lake_.csv",
    "Antelope Lake": "antelope_lake_.csv",
    "Barrett": "barrett_.csv",
    "Bear River At Camp Far West Dam": "bear_river_at_camp_far_west_dam_.csv",
    "Bear Valley Dam": "bear_valley_dam_.csv",
    "Beardsley Lake": "beardsley_lake_.csv",
    "Berryessa": "berryessa_.csv",
    "Black Butte": "black_butte_.csv",
    "Boca Reservoir": "boca_reservoir_.csv",
    "Bouquet Canyon": "bouquet_canyon_.csv",
    "Bowman Lake": "bowman_lake_.csv",
    "Bridgeport Reservoir": "bridgeport_reservoir_.csv",
    "Briones Dam": "briones_dam_.csv",
    "Buchanan Dam": "buchanan_dam_.csv",
    "Bucks Lake Storage": "bucks_lake_storage_.csv",
    "Butt Valley": "butt_valley_.csv",
    "Cachuma Lake": "cachuma_lake_.csv",
    "Calaveras": "calaveras_.csv",
    "Camanche Reservoir": "camanche_reservoir_.csv",
    "Caples Lake": "caples_lake_.csv",
    "Casitas": "casitas_.csv",
    "Castaic": "castaic_.csv",
    "Chabot": "chabot_.csv",
    "Cherry Lake": "cherry_lake_.csv",
    "Clear Lk - Cache Creek": "clear_lk_-_cache_creek_.csv",
    "Clear Lk - Klamath R": "clear_lk_-_klamath_r_.csv",
    "Cogswell Reservoir": "cogswell_reservoir_.csv",
    "Courtright": "courtright_.csv",
    "Coyote Res-sta Clara": "coyote_res-sta_clara_.csv",
    "Crane Valley": "crane_valley_.csv",
    "Cuyamaca Dam": "cuyamaca_dam_.csv",
    "Del Valle": "del_valle_.csv",
    "Diamond Valley": "diamond_valley_.csv",
    "Don Pedro Reservoir": "don_pedro_reservoir_.csv",
    "Donnells": "donnells_.csv",
    "Dwinnell": "dwinnell_.csv",
    "East Park Reservoir": "east_park_reservoir_.csv",
    "El Capitan Dam": "el_capitan_dam_.csv",
    "Englebright": "englebright_.csv",
    "Florence Lake": "florence_lake_.csv",
    "Folsom Lake": "folsom_lake_.csv",
    "French Lake": "french_lake_.csv",
    "French Meadows": "french_meadows_.csv",
    "Frenchman Dam": "frenchman_dam_.csv",
    "Friant Dam": "friant_dam_.csv",
    "Gem  Lake": "gem_lake_.csv",
    "Gerber": "gerber_.csv",
    "Gibraltar Dam": "gibraltar_dam_.csv",
    "Grant Lake": "grant_lake_.csv",
    "Haiwee": "haiwee_.csv",
    "Hell Hole": "hell_hole_.csv",
    "Henshaw": "henshaw_.csv",
    "Hetch Hetchy": "hetch_hetchy_.csv",
    "Hidden Dam": "hidden_dam_.csv",
    "Huntington Lake": "huntington_lake_.csv",
    "Ice House": "ice_house_.csv",
    "Indian Valley": "indian_valley_.csv",
    "Iron Canyon": "iron_canyon_.csv",
    "Isabella Dam": "isabella_dam_.csv",
    "Jenkinson Lake": "jenkinson_lake_.csv",
    "Kent": "kent_.csv",
    "Keswick Reservoir": "keswick_reservoir_.csv",
    "Lake Almanor": "lake_almanor_.csv",
    "Lake Britton": "lake_britton_.csv",
    "Lake Crowley": "lake_crowley_.csv",
    "Lake Davis": "lake_davis_.csv",
    "Lake Eleanor": "lake_eleanor_.csv",
    "Lake Hemet": "lake_hemet_.csv",
    "Lake Hennessey": "lake_hennessey_.csv",
    "Lake Hodges": "lake_hodges_.csv",
    "Lake Jennings": "lake_jennings_.csv",
    "Lake Mathews": "lake_mathews_.csv",
    "Lake Mccloud": "lake_mccloud_.csv",
    "Lake Mcclure": "lake_mcclure_.csv",
    "Lake Mendocino": "lake_mendocino_.csv",
    "Lake Natoma": "lake_natoma_.csv",
    "Lake Pillsbury": "lake_pillsbury_.csv",
    "Lake Piru": "lake_piru_.csv",
    "Lake San Antonio": "lake_san_antonio_.csv",
    "Lake Silverwood": "lake_silverwood_.csv",
    "Lake Spaulding S Yuba System": "lake_spaulding_s_yuba_system_.csv",
    "Lake Tahoe": "lake_tahoe_.csv",
    "Leroy Anderson": "leroy_anderson_.csv",
    "Lewiston": "lewiston_.csv",
    "Lexington Reservoir": "lexington_reservoir_.csv",
    "Little Grass Valley": "little_grass_valley_.csv",
    "Loon Lake": "loon_lake_.csv",
    "Los Banos": "los_banos_.csv",
    "Los Vaqueros Reservoir": "los_vaqueros_reservoir_.csv",
    "Loveland Reservoir": "loveland_reservoir_.csv",
    "Lower Bear": "lower_bear_.csv",
    "Lower Crystal Springs Reservoir": "lower_crystal_springs_reservoir_.csv",
    "Lower Otay": "lower_otay_.csv",
    "Mammoth Pool": "mammoth_pool_.csv",
    "Matilija Dam": "matilija_dam_.csv",
    "Miramar": "miramar_.csv",
    "Modesto Reservoir": "modesto_reservoir_.csv",
    "Morena Dam": "morena_dam_.csv",
    "Mountain Meadows": "mountain_meadows_.csv",
    "Murray Res": "murray_res_.csv",
    "Nacimiento": "nacimiento_.csv",
    "New Bullards Bar": "new_bullards_bar_.csv",
    "New Hogan Lake": "new_hogan_lake_.csv",
    "New Melones Reservoir": "new_melones_reservoir_.csv",
    "Nicasio": "nicasio_.csv",
    "Oneill Forebay": "oneill_forebay_.csv",
    "Oroville Dam": "oroville_dam_.csv",
    "Pardee": "pardee_.csv",
    "Perris": "perris_.csv",
    "Pine Flat Dam": "pine_flat_dam_.csv",
    "Prosser Creek Reservoir": "prosser_creek_reservoir_.csv",
    "Pyramid": "pyramid_.csv",
    "Railroad Canyon": "railroad_canyon_.csv",
    "Redinger Lake": "redinger_lake_.csv",
    "Relief": "relief_.csv",
    "Rollins": "rollins_.csv",
    "Saddlebag Lake Reservoir": "saddlebag_lake_reservoir_.csv",
    "Salt Springs": "salt_springs_.csv",
    "San Andreas": "san_andreas_.csv",
    "San Antonio Reservoir": "san_antonio_reservoir_.csv",
    "San Gabriel": "san_gabriel_.csv",
    "San Luis Reservoir": "san_luis_reservoir_.csv",
    "San Pablo": "san_pablo_.csv",
    "San Vicente": "san_vicente_.csv",
    "Santa Margarita Lake": "santa_margarita_lake_.csv",
    "Santiago Creek Res": "santiago_creek_res_.csv",
    "Scotts Flat": "scotts_flat_.csv",
    "Shasta Dam": "shasta_dam_.csv",
    "Shaver Lake": "shaver_lake_.csv",
    "Skinner": "skinner_.csv",
    "Slab Creek": "slab_creek_.csv",
    "Sly Creek": "sly_creek_.csv",
    "Soulajule Dam": "soulajule_dam_.csv",
    "South Lake": "south_lake_.csv",
    "Spicer Meadows": "spicer_meadows_.csv",
    "Stampede": "stampede_.csv",
    "Stony Gorge Reservoir": "stony_gorge_reservoir_.csv",
    "Strawberry": "strawberry_reservoir.csv",
    "Success Dam": "success_dam_.csv",
    "Sutherland Reservoir": "sutherland_reservoir_.csv",
    "Sweetwater Reservoir": "sweetwater_reservoir_.csv",
    "Terminus Dam": "terminus_dam_.csv",
    "Thermalito  Total": "thermalito_total_.csv",
    "Thomas A Edison": "thomas_a_edison_.csv",
    "Tinemaha Reservoir": "tinemaha_reservoir_.csv",
    "Trinity Lake": "trinity_lake_.csv",
    "Tulloch": "tulloch_.csv",
    "Turlock Lake": "turlock_lake_.csv",
    "Twitchell": "twitchell_.csv",
    "U San Leandro": "u_san_leandro_.csv",
    "Union Valley": "union_valley_.csv",
    "Upper Klamath": "upper_klamath_.csv",
    "Vail Lake": "vail_lake_.csv",
    "Warm Springs": "warm_springs_.csv",
    "Whale Rock": "whale_rock_.csv",
    "Whiskeytown Dam": "whiskeytown_dam_.csv",
    "Wishon": "wishon_.csv",
    "Big Sandy": "big_sandy_reservoir.csv",
    "Blue Mesa": "blue_mesa_reservoir.csv",
    "Caballo": "caballo_reservoir.csv",
    "Causey": "causey_reservoir.csv",
    "Crystal": "crystal_reservoir.csv",
    "Currant Creek": "currant_creek_reservoir.csv",
    "Deer Creek": "deer_creek_reservoir.csv",
    "East Canyon": "east_canyon_reservoir.csv",
    "Echo": "echo_reservoir.csv",
    "Flaming Gorge": "flaming_gorge_reservoir.csv",
    "Fontenelle": "fontenelle_reservoir.csv",
    "Fruitgrowers": "fruitgrowers_reservoir.csv",
    "Huntington North": "huntington_north_reservoir.csv",
    "Hyrum": "hyrum_reservoir.csv",
    "Jackson Gulch": "jackson_gulch_reservoir.csv",
    "Joes Valley": "joes_valley_reservoir.csv",
    "Jordanelle": "jordanelle_reservoir.csv",
    "Lake Powell": "lake_powell.csv",
    "Lake Sumner": "lake_sumner_reservoir.csv",
    "Lemon": "lemon_reservoir.csv",
    "Lost Creek Reservoir": "lost_creek_reservoir.csv",
    "McPhee": "mcphee_reservoir.csv",
    "Meeks Cabin": "meeks_cabin_reservoir.csv",
    "Moon Lake": "moon_lake_reservoir.csv",
    "Morrow Point": "morrow_point_reservoir.csv",
    "Navajo": "navajo_reservoir.csv",
    "Newton": "newton_reservoir.csv",
    "Paonia": "paonia_reservoir.csv",
    "Pineview": "pineview_reservoir.csv",
    "Red Fleet": "red_fleet_reservoir.csv",
    "Ridgway": "ridgway_reservoir.csv",
    "Rifle Gap": "rifle_gap_reservoir.csv",
    "Rockport": "rockport_reservoir.csv",
    "Santa Rosa": "santa_rosa_reservoir.csv",
    "Scofield": "scofield_reservoir.csv",
    "Silver Jack": "silver_jack_reservoir.csv",
    "Starvation": "starvation_reservoir.csv",
    "Stateline": "stateline_reservoir.csv",
    "Steinaker": "steinaker_reservoir.csv",
    "Taylor Park": "taylor_park_reservoir.csv",
    "Upper Stillwater": "upper_stillwater_reservoir.csv",
    "Vallecito": "vallecito_reservoir.csv",
    "Vega": "vega_reservoir.csv",
    "Lake Havasu": "lake_havasu_.csv",
    "Lake Mead": "lake_mead_.csv",
    "Lake Mohave": "lake_mohave_.csv",
    "Agate": "AGA.csv",
    "American Falls": "AMF.csv",
    "Anderson Ranch": "AND.csv",
    "Arrowrock": "ARK.csv",
    "Beulah": "BEU.csv",
    "Banks Lake": "BNK.csv",
    "Bully Creek": "BUL.csv",
    "Cold Springs": "CLS.csv",
    "Crane Prairie": "CRA.csv",
    "Crescent Lake": "CRE.csv",
    "Lake Cascade": "CSC.csv",
    "Deadwood": "DED.csv",
    "Drews": "DRW.csv",
    "Emigrant Lake": "EMI.csv",
    "Black Canyon": "EMM.csv",
    "Fish Lake": "FIS.csv",
    "Fourmile Lake": "FOR.csv",
    "Grand Coulee\/FDR Lake": "GCL.csv",
    "Grassy Lake": "GRS.csv",
    "Haystack": "HAY.csv",
    "Henrys Lake": "HEN.csv",
    "Howard Prairie Lake": "HPD.csv",
    "Hyatt": "HYA.csv",
    "Island Park": "ISL.csv",
    "Jackson Lake": "JCK.csv",
    "Lake Lowell": "LOW.csv",
    "Lucky Peak Lake": "LUC.csv",
    "Mann Creek": "MAN.csv",
    "McKay": "MCK.csv",
    "Milner": "MIL.csv",
    "Lake Walcott": "MIN.csv",
    "Ochoco": "OCH.csv",
    "Lake Owyhee": "OWY.csv",
    "Palisades": "PAL.csv",
    "Phillips Lake": "PHL.csv",
    "Prineville": "PRV.csv",
    "Ririe Lake": "RIR.csv",
    "Reservoir A": "RSA.csv",
    "Henry Hagg Lake": "SCO.csv",
    "Soldiers Meadow": "SOL.csv",
    "Thief Valley": "THF.csv",
    "Unity": "UNY.csv",
    "Warm Springs Reservoir": "WAR.csv",
    "Clear Lake": "OR_Clear_Lake.csv",
    "Wickiup": "WIC.csv",
    "Wildhorse": "WLD.csv",
    "Little Wood": "WOD.csv",
    "Bartlett": "bartlett.csv",
    "C. C. Cragin": "c.c.cragin.csv",
    "Horseshoe": "horseshoe.csv",
    "Lyman Lake": "lymanlake.csv",
    "San Carlos": "sancarlos.csv",
    "Horse Mesa": "horse_mesa.csv",
    "Mormon Flat": "mormon_flat.csv",
    "Roosevelt": "roosevelt.csv",
    "Stewart Mtn": "stewart_mtn.csv",
    "Adobe Creek": "CO_Adobe_Creek.csv",
    "Antero": "CO_Antero.csv",
    "Barr Lake": "CO_Barr_Lake.csv",
    "Boyd Lake": "CO_Boyd_Lake.csv",
    "Carter Lake": "CO_Carter_Lake.csv",
    "Cheesman": "CO_Cheesman.csv",
    "Clear Creek": "CO_Clear_Creek.csv",
    "Cobb Lake": "CO_Cobb_Lake.csv",
    "Continental": "CO_Continental.csv",
    "Crawford": "CO_Crawford.csv",
    "Cucharas": "CO_Cucharas.csv",
    "Dillon": "CO_Dillon.csv",
    "Eleven Mile": "CO_Eleven_Mile.csv",
    "Empire": "CO_Empire.csv",
    "Fossil Creek": "CO_Fossil_Creek.csv",
    "Green Mtn": "CO_Green_Mtn.csv",
    "Gross": "CO_Gross.csv",
    "Groundhog": "CO_Groundhog.csv",
    "Homestake": "CO_Homestake.csv",
    "Horse Creek": "CO_Horse_Creek.csv",
    "Horsecreek": "CO_Horsecreek.csv",
    "Horsetooth": "CO_Horsetooth.csv",
    "Jackson Gulch Reservoir": "CO_Jackson_Gulch_Reservoir.csv",
    "Jackson Lk": "CO_Jackson_Lk.csv",
    "John Martin": "CO_John_Martin.csv",
    "Julesberg": "CO_Julesberg.csv",
    "Lake Granby": "CO_Lake_Granby.csv",
    "Lake Loveland": "CO_Lake_Loveland.csv",
    "Marshall": "CO_Marshall.csv",
    "Marston": "CO_Marston.csv",
    "Meredith Reservoir": "CO_Meredith_Reservoir.csv",
    "Milton": "CO_Milton.csv",
    "Mountain Home": "CO_Mountain_Home.csv",
    "Narraguinnep": "CO_Narraguinnep.csv",
    "Platoro": "CO_Platoro.csv",
    "Point of Rocks": "CO_Point_of_Rocks.csv",
    "Prewitt": "CO_Prewitt.csv",
    "Pueblo": "CO_Pueblo.csv",
    "Ralph Price": "CO_Ralph_Price.csv",
    "Rio Grande": "CO_Rio_Grande.csv",
    "Riverside": "CO_Riverside.csv",
    "Ruedi": "CO_Ruedi.csv",
    "Sanchez": "CO_Sanchez.csv",
    "Santa Maria": "CO_Santa_Maria.csv",
    "Shadow Mountain": "CO_Shadow_Mountain.csv",
    "Spinney Mountain": "CO_Spinney_Mountain.csv",
    "Stagecoach": "CO_Stagecoach.csv",
    "Standley": "CO_Standley.csv",
    "Terrace": "CO_Terrace.csv",
    "Trinidad Lake": "CO_Trinidad_Lake.csv",
    "Turquoise Lake": "CO_Turquoise_Lake.csv",
    "Twin Lakes": "CO_Twin_Lakes.csv",
    "Union": "CO_Union.csv",
    "Williams Fork": "CO_Williams_Fork.csv",
    "Windsor": "CO_Windsor.csv",
    "Wolford Mountain": "CO_Wolford_Mountain.csv",
    "Bear Lake": "ID_Bear_Lake.csv",
    "Blackfoot": "ID_Blackfoot.csv",
    "Brownlee": "ID_Brownlee.csv",
    "Dworshak": "ID_Dworshak.csv",
    "Lake Coeur d'Alene": "ID_Lake_Coeur_d_Alene.csv",
    "Lake Pend Oreille": "ID_Lake_Pend_Oreille.csv",
    "Magic": "ID_Magic.csv",
    "Montpelier": "ID_Montpelier.csv",
    "Oakley": "ID_Oakley.csv",
    "Priest Lake": "ID_Priest_Lake.csv",
    "Salmon Falls": "ID_Salmon_Falls.csv",
    "Ackley Lake": "MT_Ackley_Lake.csv",
    "Ashley Lake": "MT_Ashley_Lake.csv",
    "Bair": "MT_Bair.csv",
    "Bighorn Lake": "MT_Bighorn_Lake.csv",
    "Canyon Ferry Lake": "MT_Canyon_Ferry_Lake.csv",
    "Clark Canyon": "MT_Clark_Canyon.csv",
    "Cooney": "MT_Cooney.csv",
    "Deadman's Basin": "MT_Deadman_s_Basin.csv",
    "East Fork Rock Creek": "MT_East_Fork_Rock_Creek.csv",
    "Ennis Lake": "MT_Ennis_Lake.csv",
    "Fort Peck Lake": "MT_Fort_Peck_Lake.csv",
    "Fresno": "MT_Fresno.csv",
    "Gibson": "MT_Gibson.csv",
    "Hauser Lake & Lake Helena": "MT_Hauser_Lake_&_Lake_Helena.csv",
    "Hebgen Lake": "MT_Hebgen_Lake.csv",
    "Holter Lake": "MT_Holter_Lake.csv",
    "Lake Elwell (Tiber)": "MT_Lake_Elwell_(Tiber).csv",
    "Lake Koocanusa": "MT_Lake_Koocanusa.csv",
    "Lake Sherburne": "MT_Lake_Sherburne.csv",
    "Lima": "MT_Lima.csv",
    "Lower Two Medicine Lake": "MT_Lower_Two_Medicine_Lake.csv",
    "Martinsdale": "MT_Martinsdale.csv",
    "Middle Creek": "MT_Middle_Creek.csv",
    "Nelson": "MT_Nelson.csv",
    "Nevada Creek": "MT_Nevada_Creek.csv",
    "Nilan": "MT_Nilan.csv",
    "Noxon Rapids": "MT_Noxon_Rapids.csv",
    "Painted Rocks Lake": "MT_Painted_Rocks_Lake.csv",
    "Pishkun": "MT_Pishkun.csv",
    "Ruby River": "MT_Ruby_River.csv",
    "Swift": "MT_Swift.csv",
    "Tongue River": "MT_Tongue_River.csv",
    "Abiquiu": "NM_Abiquiu.csv",
    "Bluewater Lake": "NM_Bluewater_Lake.csv",
    "Brantley Lake": "NM_Brantley_Lake.csv",
    "Cochiti Lake": "NM_Cochiti_Lake.csv",
    "Conchas Lake": "NM_Conchas_Lake.csv",
    "Costilla": "NM_Costilla.csv",
    "Eagle Nest Lake": "NM_Eagle_Nest_Lake.csv",
    "El Vado": "NM_El_Vado.csv",
    "Heron": "NM_Heron.csv",
    "Lake Avalon": "NM_Lake_Avalon.csv",
    "Lahontan": "NV_Lahontan.csv",
    "Rye Patch": "NV_Rye_Patch.csv",
    "Applegate": "OR_Applegate.csv",
    "Blue River": "OR_Blue_River.csv",
    "Cottage Grove": "OR_Cottage_Grove.csv",
    "Cottonwood": "OR_Cottonwood.csv",
    "Cougar": "OR_Cougar.csv",
    "Detroit": "OR_Detroit.csv",
    "Dorena": "OR_Dorena.csv",
    "Fall Creek": "OR_Fall_Creek.csv",
    "Fern Ridge": "OR_Fern_Ridge.csv",
    "Foster": "OR_Foster.csv",
    "Lost Creek Res": "OR_Lost_Creek_Res.csv",
    "Wallowa Lake": "OR_Wallowa_Lake.csv",
    "Willow Creek": "OR_Willow_Creek.csv",
    "Wolf Creek": "OR_Wolf_Creek.csv",
    "Big Sand Wash": "UT_Big_Sand_Wash.csv",
    "Cleveland Lake": "UT_Cleveland_Lake.csv",
    "Grantsville": "UT_Grantsville.csv",
    "Gunlock": "UT_Gunlock.csv",
    "Gunnison": "UT_Gunnison.csv",
    "Ken's Lake": "UT_Ken_s_Lake.csv",
    "Kolob": "UT_Kolob.csv",
    "Lower Enterprise": "UT_Lower_Enterprise.csv",
    "Miller Flat": "UT_Miller_Flat.csv",
    "Millsite": "UT_Millsite.csv",
    "Minersville": "UT_Minersville.csv",
    "Otter Creek": "UT_Otter_Creek.csv",
    "Panguitch Lake": "UT_Panguitch_Lake.csv",
    "Piute": "UT_Piute.csv",
    "Porcupine": "UT_Porcupine.csv",
    "Quail Creek": "UT_Quail_Creek.csv",
    "Sand Hollow": "UT_Sand_Hollow.csv",
    "Sevier Bridge": "UT_Sevier_Bridge.csv",
    "Smith and Morehouse": "UT_Smith_and_Morehouse.csv",
    "Upper Enterprise": "UT_Upper_Enterprise.csv",
    "Utah Lake": "UT_Utah_Lake.csv",
    "Willard Bay": "UT_Willard_Bay.csv",
    "Woodruff Creek": "UT_Woodruff_Creek.csv",
    "Bumping Lake": "WA_Bumping_Lake.csv",
    "Cle Elum": "WA_Cle_Elum.csv",
    "Conconully": "WA_Conconully.csv",
    "Diablo": "WA_Diablo.csv",
    "Kachess": "WA_Kachess.csv",
    "Keechelus": "WA_Keechelus.csv",
    "Lake Chelan": "WA_Lake_Chelan.csv",
    "Rimrock": "WA_Rimrock.csv",
    "Ross": "WA_Ross.csv",
    "Alcova": "WY_Alcova.csv",
    "Boysen": "WY_Boysen.csv",
    "Buffalo Bill": "WY_Buffalo_Bill.csv",
    "Bull Lake": "WY_Bull_Lake.csv",
    "Glendo": "WY_Glendo.csv",
    "Guernsey": "WY_Guernsey.csv",
    "High Savery": "WY_High_Savery.csv",
    "Keyhole": "WY_Keyhole.csv",
    "Pathfinder": "WY_Pathfinder.csv",
    "Pilot Butte": "WY_Pilot_Butte.csv",
    "Seminoe": "WY_Seminoe.csv",
    "Viva Naughton": "WY_Viva_Naughton.csv",
    "Wheatland #2": "WY_Wheatland__2.csv",
    "Woodruff Narrows": "WY_Woodruff_Narrows.csv"
  }
};



/***/ }),
/* 230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bootstrap_vue__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_bootstrap_dist_css_bootstrap_css__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_bootstrap_dist_css_bootstrap_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_bootstrap_dist_css_bootstrap_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bootstrap_vue_dist_bootstrap_vue_css__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bootstrap_vue_dist_bootstrap_vue_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_bootstrap_vue_dist_bootstrap_vue_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_css_styles_css__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_css_styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_css_styles_css__);









__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_bootstrap_vue__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 343 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 81,
	"./af.js": 81,
	"./ar": 88,
	"./ar-dz": 82,
	"./ar-dz.js": 82,
	"./ar-kw": 83,
	"./ar-kw.js": 83,
	"./ar-ly": 84,
	"./ar-ly.js": 84,
	"./ar-ma": 85,
	"./ar-ma.js": 85,
	"./ar-sa": 86,
	"./ar-sa.js": 86,
	"./ar-tn": 87,
	"./ar-tn.js": 87,
	"./ar.js": 88,
	"./az": 89,
	"./az.js": 89,
	"./be": 90,
	"./be.js": 90,
	"./bg": 91,
	"./bg.js": 91,
	"./bn": 92,
	"./bn.js": 92,
	"./bo": 93,
	"./bo.js": 93,
	"./br": 94,
	"./br.js": 94,
	"./bs": 95,
	"./bs.js": 95,
	"./ca": 96,
	"./ca.js": 96,
	"./cs": 97,
	"./cs.js": 97,
	"./cv": 98,
	"./cv.js": 98,
	"./cy": 99,
	"./cy.js": 99,
	"./da": 100,
	"./da.js": 100,
	"./de": 103,
	"./de-at": 101,
	"./de-at.js": 101,
	"./de-ch": 102,
	"./de-ch.js": 102,
	"./de.js": 103,
	"./dv": 104,
	"./dv.js": 104,
	"./el": 105,
	"./el.js": 105,
	"./en-au": 106,
	"./en-au.js": 106,
	"./en-ca": 107,
	"./en-ca.js": 107,
	"./en-gb": 108,
	"./en-gb.js": 108,
	"./en-ie": 109,
	"./en-ie.js": 109,
	"./en-nz": 110,
	"./en-nz.js": 110,
	"./eo": 111,
	"./eo.js": 111,
	"./es": 113,
	"./es-do": 112,
	"./es-do.js": 112,
	"./es.js": 113,
	"./et": 114,
	"./et.js": 114,
	"./eu": 115,
	"./eu.js": 115,
	"./fa": 116,
	"./fa.js": 116,
	"./fi": 117,
	"./fi.js": 117,
	"./fo": 118,
	"./fo.js": 118,
	"./fr": 121,
	"./fr-ca": 119,
	"./fr-ca.js": 119,
	"./fr-ch": 120,
	"./fr-ch.js": 120,
	"./fr.js": 121,
	"./fy": 122,
	"./fy.js": 122,
	"./gd": 123,
	"./gd.js": 123,
	"./gl": 124,
	"./gl.js": 124,
	"./gom-latn": 125,
	"./gom-latn.js": 125,
	"./he": 126,
	"./he.js": 126,
	"./hi": 127,
	"./hi.js": 127,
	"./hr": 128,
	"./hr.js": 128,
	"./hu": 129,
	"./hu.js": 129,
	"./hy-am": 130,
	"./hy-am.js": 130,
	"./id": 131,
	"./id.js": 131,
	"./is": 132,
	"./is.js": 132,
	"./it": 133,
	"./it.js": 133,
	"./ja": 134,
	"./ja.js": 134,
	"./jv": 135,
	"./jv.js": 135,
	"./ka": 136,
	"./ka.js": 136,
	"./kk": 137,
	"./kk.js": 137,
	"./km": 138,
	"./km.js": 138,
	"./kn": 139,
	"./kn.js": 139,
	"./ko": 140,
	"./ko.js": 140,
	"./ky": 141,
	"./ky.js": 141,
	"./lb": 142,
	"./lb.js": 142,
	"./lo": 143,
	"./lo.js": 143,
	"./lt": 144,
	"./lt.js": 144,
	"./lv": 145,
	"./lv.js": 145,
	"./me": 146,
	"./me.js": 146,
	"./mi": 147,
	"./mi.js": 147,
	"./mk": 148,
	"./mk.js": 148,
	"./ml": 149,
	"./ml.js": 149,
	"./mr": 150,
	"./mr.js": 150,
	"./ms": 152,
	"./ms-my": 151,
	"./ms-my.js": 151,
	"./ms.js": 152,
	"./my": 153,
	"./my.js": 153,
	"./nb": 154,
	"./nb.js": 154,
	"./ne": 155,
	"./ne.js": 155,
	"./nl": 157,
	"./nl-be": 156,
	"./nl-be.js": 156,
	"./nl.js": 157,
	"./nn": 158,
	"./nn.js": 158,
	"./pa-in": 159,
	"./pa-in.js": 159,
	"./pl": 160,
	"./pl.js": 160,
	"./pt": 162,
	"./pt-br": 161,
	"./pt-br.js": 161,
	"./pt.js": 162,
	"./ro": 163,
	"./ro.js": 163,
	"./ru": 164,
	"./ru.js": 164,
	"./sd": 165,
	"./sd.js": 165,
	"./se": 166,
	"./se.js": 166,
	"./si": 167,
	"./si.js": 167,
	"./sk": 168,
	"./sk.js": 168,
	"./sl": 169,
	"./sl.js": 169,
	"./sq": 170,
	"./sq.js": 170,
	"./sr": 172,
	"./sr-cyrl": 171,
	"./sr-cyrl.js": 171,
	"./sr.js": 172,
	"./ss": 173,
	"./ss.js": 173,
	"./sv": 174,
	"./sv.js": 174,
	"./sw": 175,
	"./sw.js": 175,
	"./ta": 176,
	"./ta.js": 176,
	"./te": 177,
	"./te.js": 177,
	"./tet": 178,
	"./tet.js": 178,
	"./th": 179,
	"./th.js": 179,
	"./tl-ph": 180,
	"./tl-ph.js": 180,
	"./tlh": 181,
	"./tlh.js": 181,
	"./tr": 182,
	"./tr.js": 182,
	"./tzl": 183,
	"./tzl.js": 183,
	"./tzm": 185,
	"./tzm-latn": 184,
	"./tzm-latn.js": 184,
	"./tzm.js": 185,
	"./uk": 186,
	"./uk.js": 186,
	"./ur": 187,
	"./ur.js": 187,
	"./uz": 189,
	"./uz-latn": 188,
	"./uz-latn.js": 188,
	"./uz.js": 189,
	"./vi": 190,
	"./vi.js": 190,
	"./x-pseudo": 191,
	"./x-pseudo.js": 191,
	"./yo": 192,
	"./yo.js": 192,
	"./zh-cn": 193,
	"./zh-cn.js": 193,
	"./zh-hk": 194,
	"./zh-hk.js": 194,
	"./zh-tw": 195,
	"./zh-tw.js": 195
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 344;

/***/ }),
/* 345 */,
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(207),
  /* template */
  __webpack_require__(369),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(208),
  /* template */
  __webpack_require__(382),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(209),
  /* template */
  __webpack_require__(379),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(211),
  /* template */
  __webpack_require__(368),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(212),
  /* template */
  __webpack_require__(373),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(214),
  /* template */
  __webpack_require__(384),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(342)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(216),
  /* template */
  __webpack_require__(371),
  /* scopeId */
  "data-v-3278f51d",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(217),
  /* template */
  __webpack_require__(366),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(219),
  /* template */
  __webpack_require__(374),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(220),
  /* template */
  __webpack_require__(378),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(221),
  /* template */
  __webpack_require__(367),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(222),
  /* template */
  __webpack_require__(375),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(225),
  /* template */
  __webpack_require__(365),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(226),
  /* template */
  __webpack_require__(362),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(227),
  /* template */
  __webpack_require__(377),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(228),
  /* template */
  __webpack_require__(363),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 362 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('utah-map', {
    attrs: {
      "mapFile": "ut.counties.json",
      "dataFile": "utah_load.csv",
      "res": "Steinaker",
      "resFile": "utah.json",
      "whichState": "UT"
    }
  }), _vm._v(" "), _c('snow-chart', {
    attrs: {
      "whichState": "UT"
    }
  }), _vm._v(" "), _c('drought-map', {
    attrs: {
      "mapFile": "ut.counties.json",
      "centersFile": "ut_centers.json",
      "dataFile": "ut-counties.csv"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 363 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('wyoming-map', {
    attrs: {
      "mapFile": "wy.counties.json",
      "dataFile": "wy_load.csv",
      "res": "Fontenelle",
      "resFile": "wy.json",
      "whichState": "WY"
    }
  }), _vm._v(" "), _c('snow-chart', {
    attrs: {
      "whichState": "WY"
    }
  }), _vm._v(" "), _c('drought-map', {
    attrs: {
      "mapFile": "wy.counties.json",
      "centersFile": "wy_centers.json",
      "dataFile": "wy-counties.csv"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 364 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12 col-lg-12 offset"
  }, [(_vm.done) ? _c('div', [_c('h3', {
    staticClass: "text-center"
  }, [_vm._v("Drought Levels by " + _vm._s(_vm.droughtType))]), _vm._v(" "), _c('p', {
    staticClass: "offset-sm-1 col-sm-10 offset-lg-1 col-lg-10 text-top-drought"
  }, [_vm._v("\n      The following chart shows drought level by " + _vm._s(_vm.droughtTypeLower) + " as reported by the\n      "), _c('a', {
    staticClass: "inside",
    attrs: {
      "href": "https://droughtmonitor.unl.edu"
    }
  }, [_vm._v("United States Drought Monitor")]), _vm._v(". Drought levels are represented by a series of nested\n      circles. The larger the circle the greater percentage of the " + _vm._s(_vm.droughtTypeLower) + " that is at that drought level.\n    In extreme cases, e.g. 100% drought levels, the circles will overlap. If there is no drought in a " + _vm._s(_vm.droughtTypeLower) + "\n    there won't be any circles at all. Hover over a circle to see the levels for a\n    particular " + _vm._s(_vm.droughtTypeLower) + ". See the legends below the map for full details.")]), _vm._v(" "), _c('vue-slider', _vm._b({
    ref: "slider",
    on: {
      "callback": _vm.updateSlider
    },
    model: {
      value: (_vm.slider_data.value),
      callback: function($$v) {
        _vm.slider_data.value = $$v
      },
      expression: "slider_data.value"
    }
  }, 'vue-slider', _vm.slider_data))], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.done),
      expression: "done"
    }]
  }, [_c('svg', {
    staticClass: "is-map",
    attrs: {
      "id": "drought_map",
      "height": _vm.graph_height,
      "width": _vm.graph_width
    }
  }, [_vm._l((_vm.centers), function(d, index) {
    return [_c('g', {
      on: {
        "mouseover": function($event) {
          _vm.showItem(d, _vm.tipDiv, $event)
        },
        "mouseout": function($event) {
          _vm.hideItem(d, _vm.tipDiv, $event)
        },
        "touchstart": function($event) {
          _vm.showItem(d, _vm.tipDiv, $event)
        },
        "touchend": function($event) {
          _vm.hideItem(d, _vm.tipDiv, $event)
        }
      }
    }, _vm._l((_vm.num_circles), function(j) {
      return _c('circle', {
        style: ({
          stroke: _vm.colors[j]
        }),
        attrs: {
          "cx": _vm.projection([d.lon, d.lat])[0],
          "cy": _vm.projection([d.lon, d.lat])[1],
          "r": _vm.findValue(d, _vm.filtered_data, j)
        }
      })
    }))]
  })], 2), _vm._v(" "), _c('drought-legend-chart', {
    attrs: {
      "colors": _vm.colors
    }
  }), _vm._v(" "), _vm._m(0)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "offset-sm-1 col-sm-10"
  }, [_c('p', [_vm._v("If you have any questions or comments feel free to contact me via Twitter at @farrelldlfarrel, or email\n        at farrelldlfarrell at gmail.com")])])
}]}

/***/ }),
/* 365 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('texas-map', {
    attrs: {
      "mapFile": "tx.counties.json",
      "dataFile": "tx_load.csv",
      "res": "Meredith",
      "resFile": "texas_resv.json",
      "whichState": "TX"
    }
  }), _vm._v(" "), _c('drought-map', {
    attrs: {
      "mapFile": "tx.counties.json",
      "centersFile": "tx_centers.json",
      "dataFile": "tx-counties.csv"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 366 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('main-map', {
    attrs: {
      "mapFile": "contig_us.geo.json",
      "dataFile": "all_load.csv",
      "res": "Shasta Dam",
      "resFile": "all_resv.json",
      "hasKey": _vm.hasKey,
      "whichState": "none"
    }
  }), _vm._v(" "), _c('snow-chart', {
    attrs: {
      "whichState": "main"
    }
  }), _vm._v(" "), _c('drought-map', {
    attrs: {
      "mapFile": "western_us.json",
      "centersFile": "all_centers.json",
      "dataFile": "all.csv"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 367 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nm-map', {
    attrs: {
      "mapFile": "nm.counties.json",
      "dataFile": "nm_load.csv",
      "res": "Caballo",
      "resFile": "nm.json",
      "whichState": "NM"
    }
  }), _vm._v(" "), _c('snow-chart', {
    attrs: {
      "whichState": "NM"
    }
  }), _vm._v(" "), _c('drought-map', {
    attrs: {
      "mapFile": "nm.counties.json",
      "centersFile": "nm_centers.json",
      "dataFile": "nm-counties.csv"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 368 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('colorado-map', {
    attrs: {
      "mapFile": "co.counties.json",
      "dataFile": "co_load.csv",
      "res": "Vallecito",
      "resFile": "co.json",
      "whichState": "CO"
    }
  }), _vm._v(" "), _c('snow-chart', {
    attrs: {
      "whichState": "CO"
    }
  }), _vm._v(" "), _c('drought-map', {
    attrs: {
      "mapFile": "co.counties.json",
      "centersFile": "co_centers.json",
      "dataFile": "co-counties.csv"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 369 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("Western Water - Introduction")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "offset-sm-1 col-sm-10 offset-lg-1 col-lg-10"
  }, [_c('p', [_vm._v("Much of the American West is in a prolonged drought. Western Water tracks the water levels of reservoirs in several western states. It is a proxy for water availability\n        in the selected states more generally. Results will be updated monthly. The initial goal was to update levels daily,\n        but there isn't enough daily change in reservoir levels to warrant such granularity.")]), _vm._v(" "), _c('p', [_vm._v("Western Water does not include water from desalination plants, ground water, or water pulled directly from rivers\n        Instead it focuses on water stored in reservoirs.")]), _vm._v(" "), _c('p', [_vm._v("Data does not include every reservoir in California. Data for some reservoirs was not available for various reasons; mainly due to\n        an inability to scrape data or determine a reservoir's capacity. Nor is water from reservoirs on the Colorado river,\n        which provides water to much of southern California, as I found no way\n        to quantify how much water in each reservoir: Havasu, Mead and Powell, belongs to California, as each\n        reservoir lies wholly or in part outside the state. The Colorado River\n        Compact guarantees California 4,400,000 acre feet a year. So\n        you can spread it among the Colorado River reservoirs however you see fit. If there\n        is a shortfall in available water in the river California's water rights trump Arizona's.")]), _vm._v(" "), _c('p', [_vm._v("Texas reservoir data should be complete. a class=\"inside\" handful of reservoirs in Texas are shared with other states or countries, with\n        the water split as a percentage between the agreement partners. The reservoir capacities and volume in the visualization\n        are based on Texas' percentages, except as noted below.")]), _vm._v(" "), _c('p', [_vm._v("The shared reservoirs are (per "), _c('a', {
    staticClass: "inside",
    attrs: {
      "href": "http://waterdatafortexas.org/"
    }
  }, [_vm._v("http://waterdatafortexas.org")]), _vm._v("):\n      "), _c('ul', [_c('li', [_vm._v("Lake Amistad, shared with Mexico: 56.2% of reservoir belongs to Texas.")]), _vm._v(" "), _c('li', [_vm._v("Lake Falcon, shared with Mexico: 58.6% of reservoir belongs to Texas.")]), _vm._v(" "), _c('li', [_vm._v("Caddo Lake, shared with Louisiana: 50.0% of reservoir belongs to Texas")]), _vm._v(" "), _c('li', [_vm._v("Elephant Butte Lake, shared with Colorado, New Mexico, Texas and the Mexican state of Chihuahua.")]), _vm._v(" "), _c('li', [_vm._v("Lake Meredith, shared with New Mexico and Oklahoma: 500,000 acre feet belong to Texas after New Mexico's\n          allotment of 200,000 acre feet are held in Ute Lake. Texas must release water beyond its allotment\n          to Oklahoma.")]), _vm._v(" "), _c('li', [_vm._v("Lake Texoma, shared with Oklahoma: 50.0% of reservoir belongs to Texas")]), _vm._v(" "), _c('li', [_vm._v("Toledo Bend Reservoir, shared with Louisiana: 50.0% of reservoir belongs to Texas")])])]), _c('p', [_vm._v("The goal is to include reservoirs from across the west, particularly the states in the Colorado River basin:\n        Colorado, Wyoming, Utah, New Mexico, Nevada, Arizona and California. However, it has been difficult to find historical\n        data for most states. For example, the United States Bureau of Reclamation maintains separate web sites for the upper and lower\n        Colorado. Reclamation staff have been very helpful in navigating their data, but technological issues with loading pages from the\n        Bureau's sites have made it difficult to grab data via scripting.  More often than not, page loads\n        fail when accessing Bureau data via Curl.\n      ")]), _vm._v(" "), _c('p', [_vm._v("Historical averages would be a nice addition. These are available for California reservoirs, but not for other states or snow\n        data. My plan is to calculate averages from the data I do have.")]), _vm._v(" "), _c('p', [_vm._v("Ground water usage is also of interest, though data is difficult if not impossible\n        to obtain, as for instance, California doesn't track groundwater use.")]), _vm._v(" "), _c('p', [_vm._v("Data courtesy of the following locations:")]), _vm._v(" "), _c('ul', {
    staticClass: "no-style"
  }, [_c('li', [_c('a', {
    staticClass: "inside",
    attrs: {
      "href": "http://cdec.water.ca.gov"
    }
  }, [_vm._v("California Data Exchange Center")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "inside",
    attrs: {
      "href": "http://waterdatafortexas.org/"
    }
  }, [_vm._v("Water Data for Texas")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "inside",
    attrs: {
      "href": "http://waterdata.usgs.gov/"
    }
  }, [_vm._v("United States Geological Survey - National Water Information System")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "inside",
    attrs: {
      "href": "https://www.usbr.gov/"
    }
  }, [_vm._v("United States Bureau of Reclamation")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "inside",
    attrs: {
      "href": "http://data.hydrometdataservice.info/dwr/"
    }
  }, [_vm._v("Salt River Project")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "inside",
    attrs: {
      "href": "http://www.nwd.usace.army.mil/Media/Fact-Sheets/Fact-Sheet-Article-View/Article/475820/columbia-river-basin-dams/"
    }
  }, [_vm._v("US Army Corps of Engineers - Northwestern Division")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "inside",
    attrs: {
      "href": "http://www.wcc.nrcs.usda.gov/snow/"
    }
  }, [_vm._v("United States Dept of Agriculture - Natural Resources Conservation Service")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "inside",
    attrs: {
      "href": "http://www.denverwater.org/SupplyPlanning/WaterSupply/ReservoirLevels/"
    }
  }, [_vm._v("Denver Water")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "inside",
    attrs: {
      "href": "http://www.waterquality.utah.gov/"
    }
  }, [_vm._v("Utah Department of Environmental Quality - Division of Water Quality")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "inside",
    attrs: {
      "href": "https://en.wikipedia.org/"
    }
  }, [_vm._v("Wikipedia")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "inside",
    attrs: {
      "href": "https://tools.wmflabs.org/geohack/"
    }
  }, [_vm._v("GeoHack")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "inside",
    attrs: {
      "href": "http://www.lat-long.com/"
    }
  }, [_vm._v("http://www.lat-long.com")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "inside",
    attrs: {
      "href": "http://catalog.opendata.city/"
    }
  }, [_vm._v("opendata.city")])])]), _vm._v(" "), _c('p', [_vm._v("Project built using:")]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    staticClass: "inside",
    attrs: {
      "href": "https://d3js.org/"
    }
  }, [_vm._v("D3.js")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "inside",
    attrs: {
      "href": "https://vuejs.org"
    }
  }, [_vm._v("Vue.js")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "inside",
    attrs: {
      "href": "http://simplehtmldom.sourceforge.net/"
    }
  }, [_vm._v("PHP Simple HTML DOM Parser")])])]), _vm._v(" "), _c('p', [_vm._v("If you have questions or comments feel free to contact me on Twitter at "), _c('a', {
    staticClass: "inside",
    attrs: {
      "href": "https://twitter.com/farrelldlfarrel"
    }
  }, [_vm._v("@farrelldlfarrel")])])])])])
}]}

/***/ }),
/* 370 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'circle-legend': _vm.centerClass
    }
  }, [_c('svg', {
    attrs: {
      "width": _vm.width,
      "height": _vm.height,
      "transform": _vm.translate
    }
  }, [_c('g', {
    attrs: {
      "id": _vm.field,
      "width": _vm.width,
      "transform": "translate(20,15)"
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 371 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12 col-lg-6",
    attrs: {
      "id": "graph"
    }
  }, [_c('h3', [_vm._v("Reservoir: "), _c('span', [_vm._v(_vm._s(_vm.location))])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("21st Century Average Volume: "), _c('span', [_vm._v(_vm._s(_vm.res_avg))]), _vm._v(" acre feet")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "res_legend"
    }
  }, [_c('svg', {
    attrs: {
      "width": "450",
      "height": "45",
      "transform": "translate(70,0)"
    }
  }, [_c('g', [_c('rect', {
    staticStyle: {
      "fill": "rgb(252, 232, 131)"
    },
    attrs: {
      "x": "55",
      "y": "15",
      "width": "10",
      "height": "10"
    }
  }), _vm._v(" "), _c('text', {
    attrs: {
      "x": "70",
      "y": "25",
      "height": "30",
      "width": "50"
    }
  }, [_vm._v("Avg Levels")])]), _vm._v(" "), _c('g', [_c('rect', {
    staticStyle: {
      "fill": "steelblue"
    },
    attrs: {
      "x": "150",
      "y": "15",
      "width": "10",
      "height": "10"
    }
  }), _vm._v(" "), _c('text', {
    attrs: {
      "x": "165",
      "y": "25",
      "height": "30",
      "width": "50"
    }
  }, [_vm._v("Current Storage")])])])]), _vm._v(" "), _c('svg', {
    attrs: {
      "id": "line-chart"
    }
  }, [_c('g', {
    staticClass: "x axis",
    attrs: {
      "transform": ("translate(" + (this.margins().left) + "," + ((this.graph_height + this.margins().top)) + ")")
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "y axis",
    attrs: {
      "transform": _vm.graph_translate
    }
  }), _vm._v(" "), _c('text', {
    attrs: {
      "x": _vm.graph_width / 1.5,
      "y": _vm.graph_height + this.margins().bottom,
      "text-anchor": "zs"
    }
  }, [_vm._v("Date")]), _vm._v(" "), _c('text', {
    staticStyle: {
      "text-anchor": "end"
    },
    attrs: {
      "transform": "rotate(-90)",
      "x": -_vm.graph_height / 2,
      "y": "6",
      "dy": ".71em"
    }
  }, [_vm._v("Acre Feet")]), _vm._v(" "), _c('g', [_c('path', {
    attrs: {
      "id": "storage",
      "d": _vm.storage,
      "stroke": "steelblue",
      "transform": _vm.graph_translate
    }
  })]), _vm._v(" "), _c('g', [_c('path', {
    attrs: {
      "id": "avg_storage",
      "d": _vm.avg_storage,
      "stroke": "#FCE883",
      "stroke-dasharray": "5,5",
      "transform": _vm.graph_translate
    }
  })]), _vm._v(" "), _c('g', {
    staticClass: "focus",
    staticStyle: {
      "display": "none"
    }
  }, [_c('line', {
    staticClass: "y0",
    attrs: {
      "x1": "0",
      "x2": "0",
      "y1": "0",
      "y2": _vm.graph_height
    }
  })]), _vm._v(" "), _c('rect', {
    staticClass: "overlay",
    attrs: {
      "height": _vm.graph_height,
      "width": _vm.graph_width
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 372 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('b-navbar', {
    attrs: {
      "toggleable": "",
      "type": "inverse",
      "variant": "inverse",
      "fixed": "top"
    }
  }, [_c('b-nav-toggle', {
    attrs: {
      "target": "nav_collapse"
    }
  }), _vm._v(" "), _c('b-link', {
    staticClass: "navbar-brand",
    attrs: {
      "to": "/"
    }
  }, [_c('span', [_vm._v("Western Water (2000-2025)")])]), _vm._v(" "), _c('b-collapse', {
    attrs: {
      "is-nav": "",
      "id": "nav_collapse"
    }
  }, [_c('b-nav', {
    attrs: {
      "is-nav-bar": ""
    }
  }, [_c('b-nav-item-dropdown', {
    attrs: {
      "text": "Lower Colorado States"
    }
  }, [_c('b-dropdown-item', {
    attrs: {
      "to": "/arizona"
    }
  }, [_vm._v("Arizona")]), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "to": "/california"
    }
  }, [_vm._v("California")]), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "to": "/nevada"
    }
  }, [_vm._v("Nevada")])], 1), _vm._v(" "), _c('b-nav-item-dropdown', {
    attrs: {
      "text": "Upper Colorado States"
    }
  }, [_c('b-dropdown-item', {
    attrs: {
      "to": "/colorado"
    }
  }, [_vm._v("Colorado")]), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "to": "/new_mexico"
    }
  }, [_vm._v("New Mexico")]), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "to": "/utah"
    }
  }, [_vm._v("Utah")]), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "to": "/wyoming"
    }
  }, [_vm._v("Wyoming")])], 1), _vm._v(" "), _c('b-nav-item-dropdown', {
    attrs: {
      "text": "Pacific Northwest States"
    }
  }, [_c('b-dropdown-item', {
    attrs: {
      "to": "/idaho"
    }
  }, [_vm._v("Idaho")]), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "to": "/montana"
    }
  }, [_vm._v("Montana")]), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "to": "/oregon"
    }
  }, [_vm._v("Oregon")]), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "to": "/washington"
    }
  }, [_vm._v("Washington")])], 1), _vm._v(" "), _c('b-nav-item', {
    attrs: {
      "to": "/texas"
    }
  }, [_vm._v("Texas")]), _vm._v(" "), _c('b-nav-item', {
    attrs: {
      "to": "/about"
    }
  }, [_vm._v("About")]), _vm._v(" "), _c('b-nav-item', {
    attrs: {
      "href": "http://www.deanfarr.com"
    }
  }, [_vm._v("Other Visuals")])], 1)], 1)], 1), _vm._v(" "), _c('router-view', {})], 1)
},staticRenderFns: []}

/***/ }),
/* 373 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row color-legend offset",
    attrs: {
      "id": "drought_circle_legend"
    }
  }, [_c('div', {
    staticClass: "col-xs-12 offset-sm-2 col-sm-5 offset-lg-1 col-lg-5 circle-legend"
  }, [_c('h3', {
    staticClass: "droughty"
  }, [_vm._v("Percentage of State at a Particular Drought Level")]), _vm._v(" "), _c('svg', {
    staticClass: "legend",
    attrs: {
      "width": "350",
      "height": "55"
    }
  }, [_c('text', {
    attrs: {
      "x": "1",
      "y": "35",
      "height": "30",
      "width": "25"
    }
  }, [_vm._v("\n        Smaller\n      ")]), _vm._v(" "), _c('g', {
    attrs: {
      "width": "350"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "60",
      "cy": "15",
      "r": "3",
      "transform": "translate(0,15)"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "width": "350"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "80",
      "cy": "15",
      "r": "8",
      "transform": "translate(0,15)"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "width": "350"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "110",
      "cy": "15",
      "r": "13",
      "transform": "translate(0,15)"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "width": "350"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "150",
      "cy": "15",
      "r": "18",
      "transform": "translate(0,15)"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "width": "350"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "200",
      "cy": "15",
      "r": "23",
      "transform": "translate(0,15)"
    }
  })]), _vm._v(" "), _c('text', {
    attrs: {
      "x": "233",
      "y": "35",
      "height": "30",
      "width": "25"
    }
  }, [_vm._v("\n        Greater\n      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-4 col-lg-4 circle-legend"
  }, [_c('h3', {
    staticClass: "droughty"
  }, [_vm._v("Interpreting the Drought Circles")]), _vm._v(" "), _c('svg', {
    attrs: {
      "width": "325",
      "height": "100"
    }
  }, [_c('g', {
    staticClass: "color-legend",
    attrs: {
      "transform": "translate(35,25)"
    }
  }, [_c('circle', {
    staticStyle: {
      "stroke": "rgb(255, 255, 212)"
    },
    attrs: {
      "cx": "50",
      "cy": "15",
      "r": "30"
    }
  }), _vm._v(" "), _c('circle', {
    staticStyle: {
      "stroke": "rgb(254, 217, 142)"
    },
    attrs: {
      "cx": "50",
      "cy": "15",
      "r": "25"
    }
  }), _vm._v(" "), _c('circle', {
    staticStyle: {
      "stroke": "rgb(254, 153, 41)"
    },
    attrs: {
      "cx": "50",
      "cy": "15",
      "r": "20"
    }
  }), _vm._v(" "), _c('circle', {
    staticStyle: {
      "stroke": "rgb(217, 95, 14)"
    },
    attrs: {
      "cx": "50",
      "cy": "15",
      "r": "15"
    }
  }), _vm._v(" "), _c('circle', {
    staticStyle: {
      "stroke": "rgb(153, 52, 4)"
    },
    attrs: {
      "cx": "50",
      "cy": "15",
      "r": "10"
    }
  })]), _vm._v(" "), _c('g', {
    staticClass: "annotations"
  }, [_c('g', {
    attrs: {
      "transform": "translate(125,100)"
    }
  }, [_c('text', {
    attrs: {
      "transform": "translate(11,-85)"
    }
  }, [_vm._v("\n            Abnormally Dry (D0)\n          ")]), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M-30,-89L5,-89"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "transform": "translate(125,100)"
    }
  }, [_c('text', {
    attrs: {
      "transform": "translate(11,-65)"
    }
  }, [_vm._v("\n            Moderate Drought (D1)\n          ")]), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M-18,-71L3,-71"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "transform": "translate(125,100)"
    }
  }, [_c('text', {
    attrs: {
      "transform": "translate(11,-45)"
    }
  }, [_vm._v("\n            Severe Drought (D2)\n          ")]), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M-21,-61L3,-52"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "transform": "translate(125,100)"
    }
  }, [_c('text', {
    attrs: {
      "transform": "translate(11,-25)"
    }
  }, [_vm._v("\n            Extreme Drought (D3)\n          ")]), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M-26,-56L4,-34"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "transform": "translate(125,100)"
    }
  }, [_c('text', {
    attrs: {
      "transform": "translate(11,-5)"
    }
  }, [_vm._v("\n            Exceptional Drought (D4)\n          ")]), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M-36,-51L5,-14"
    }
  })])])])]), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12 col-lg-12"
  }, [_c('h3', {
    staticClass: "droughty text-center offset"
  }, [_vm._v("Drought Effects")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 offset-sm-3 col-sm-9 offset-lg-3 col-lg-8"
  }, [_c('p', [_vm._v("The "), _c('a', {
    staticClass: "inside",
    attrs: {
      "href": "http://droughtmonitor.unl.edu/AboutUs/ClassificationScheme.aspx"
    }
  }, [_vm._v("United States Drought\n        Monitor")]), _vm._v(" defines the effects of various drought levels as follows:")]), _vm._v(" "), _c('ul', {
    staticClass: "list-unstyled"
  }, [_c('li', [_vm._v("DO\n          "), _c('ul', [_c('li', [_vm._v("Short-term dryness slowing planting, growth of crops or pastures")])])]), _vm._v(" "), _c('li', [_vm._v("D1\n          "), _c('ul', [_c('li', [_vm._v("Some damage to crops, pastures")]), _vm._v(" "), _c('li', [_vm._v("Streams, reservoirs, or wells low, some water shortages developing or imminent")]), _vm._v(" "), _c('li', [_vm._v(" Voluntary water-use restrictions requested")])])]), _vm._v(" "), _c('li', [_vm._v("D2\n          "), _c('ul', [_c('li', [_vm._v("Crop or pasture losses likely")]), _vm._v(" "), _c('li', [_vm._v("Water shortages common")]), _vm._v(" "), _c('li', [_vm._v("Water restrictions imposed")])])]), _vm._v(" "), _c('li', [_vm._v("D3\n          "), _c('ul', [_c('li', [_vm._v("Major crop/pasture losses")]), _vm._v(" "), _c('li', [_vm._v("Widespread water shortages or restrictions")])])]), _vm._v(" "), _c('li', [_vm._v("D4\n          "), _c('ul', [_c('li', [_vm._v("Exceptional and widespread crop/pasture losses")]), _vm._v(" "), _c('li', [_vm._v("Shortages of water in reservoirs, streams, and wells creating water emergencies")])])])])])])
}]}

/***/ }),
/* 374 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('montana-map', {
    attrs: {
      "mapFile": "mt.counties.json",
      "dataFile": "mt_load.csv",
      "res": "Lake Koocanusa",
      "resFile": "mt.json",
      "whichState": "MT"
    }
  }), _vm._v(" "), _c('snow-chart', {
    attrs: {
      "whichState": "MT"
    }
  }), _vm._v(" "), _c('drought-map', {
    attrs: {
      "mapFile": "mt.counties.json",
      "centersFile": "mt_centers.json",
      "dataFile": "mt-counties.csv"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 375 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('oregon-map', {
    attrs: {
      "mapFile": "or.counties.json",
      "dataFile": "or_load.csv",
      "res": "Lake Owyhee",
      "resFile": "or.json",
      "whichState": "OR"
    }
  }), _vm._v(" "), _c('snow-chart', {
    attrs: {
      "whichState": "OR"
    }
  }), _vm._v(" "), _c('drought-map', {
    attrs: {
      "mapFile": "or.counties.json",
      "centersFile": "or_centers.json",
      "dataFile": "or-counties.csv"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 376 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12 col-lg-12",
    attrs: {
      "id": "drought-strip"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.done),
      expression: "done"
    }]
  }, [(this.stripType === 'drought') ? _c('h3', {
    staticClass: "text-center"
  }, [_vm._v("Drought Level (" + _vm._s(_vm.areaType) + " Wide Palmer Drought Index)")]) : (this.stripType === 'precip') ? _c('h4', {
    staticClass: "text-center"
  }, [_vm._v("Precipitation Level (" + _vm._s(_vm.areaType) + " Wide)")]) : _c('h4', {
    staticClass: "text-center"
  }, [_vm._v("Temperature Level (" + _vm._s(_vm.areaType) + " Wide)")]), _vm._v(" "), (this.stripType === 'drought') ? _c('p', {
    staticClass: "offset-sm-1 col-sm-10 offset-lg-1 col-lg-10 text-top-palmer"
  }, [_vm._v("\n      The "), _c('a', {
    staticClass: "inside",
    attrs: {
      "href": "https://en.wikipedia.org/wiki/Palmer_drought_index"
    }
  }, [_vm._v("Palmer Drought Index")]), _vm._v("\n      is a measure of long term drought. It calculates soil moisture based on\n      recent precipitation and temperature. 0 is considered a normal level of soil moisture,\n      while increasingly negative numbers indicate progressively severe levels of drought.\n      Positive numbers represent increasingly wet soil conditions. Compare the Palmer Index to the\n      temperature and precipitation levels below. Recent droughts have tended to have hotter  temperatures\n      than usual. This results in increased levels of\n      "), _c('a', {
    staticClass: "inside",
    attrs: {
      "href": "https://en.wikipedia.org/wiki/Evapotranspiration"
    }
  }, [_vm._v("evapotranspiration")]), _vm._v("\n      from the soil and plants, leading to more\n      severe droughts and worse Palmer Index numbers.")]) : _vm._e(), _vm._v(" "), (this.stripType === 'drought') ? _c('p', {
    staticClass: "offset-sm-1 col-sm-10 offset-lg-1 col-lg-10"
  }, [_vm._v("\n      Note: Hover over a bar to see the value for a particular month.")]) : _vm._e(), _vm._v(" "), _c('h5', {
    staticClass: "text-center"
  }, [_vm._v("Departure from Average (Avg Anomaly)")])]), _vm._v(" "), _c('legend-chart', {
    attrs: {
      "colors": _vm.colors,
      "dataValues": _vm.dataValues,
      "field": _vm.legend_field
    }
  }), _vm._v(" "), _c('svg', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.done),
      expression: "done"
    }],
    attrs: {
      "id": "strip",
      "height": "110",
      "width": _vm.width_large
    }
  }, [_vm._l((_vm.data), function(d) {
    return [_c('rect', {
      attrs: {
        "x": _vm.scale(d.date),
        "y": "0",
        "height": _vm.height,
        "width": _vm.barWidth,
        "fill": _vm.stripColor(d.anomaly),
        "transform": _vm.offset
      },
      on: {
        "mouseover": function($event) {
          _vm.showItem(d, _vm.tipDiv, $event)
        },
        "mouseout": function($event) {
          _vm.hideItem(_vm.tipDiv, $event)
        },
        "touchstart": function($event) {
          _vm.showItem(d, _vm.tipDiv, $event)
        },
        "touchend": function($event) {
          _vm.hideItem(_vm.tipDiv, $event)
        }
      }
    })]
  })], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 377 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('washington-map', {
    attrs: {
      "mapFile": "wa.counties.json",
      "dataFile": "wa_load.csv",
      "res": "Grand Coulee/FDR Lake",
      "resFile": "wa.json",
      "whichState": "WA"
    }
  }), _vm._v(" "), _c('snow-chart', {
    attrs: {
      "whichState": "WA"
    }
  }), _vm._v(" "), _c('drought-map', {
    attrs: {
      "mapFile": "wa.counties.json",
      "centersFile": "wa_centers.json",
      "dataFile": "wa-counties.csv"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 378 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nevada-map', {
    attrs: {
      "mapFile": "nv.counties.json",
      "dataFile": "nv_load.csv",
      "res": "Lake Mead",
      "resFile": "nv.json",
      "whichState": "NV"
    }
  }), _vm._v(" "), _c('snow-chart', {
    attrs: {
      "whichState": "NV"
    }
  }), _vm._v(" "), _c('drought-map', {
    attrs: {
      "mapFile": "nv.counties.json",
      "centersFile": "nv_centers.json",
      "dataFile": "nv-counties.csv"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 379 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('california-map', {
    attrs: {
      "mapFile": "ca.counties.json",
      "dataFile": "ca_load.csv",
      "res": "Shasta Dam",
      "resFile": "ca.json",
      "whichState": "CA"
    }
  }), _vm._v(" "), _c('snow-chart', {
    attrs: {
      "whichState": "CA"
    }
  }), _vm._v(" "), _c('drought-map', {
    attrs: {
      "mapFile": "ca.counties.json",
      "centersFile": "ca_centers.json",
      "dataFile": "ca-counties.csv"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 380 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "width": _vm.width,
      "height": _vm.height,
      "transform": _vm.translate
    }
  }, [_c('g', {
    attrs: {
      "id": _vm.field,
      "width": _vm.width
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 381 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "is-top"
    }
  }, [(_vm.loading) ? _c('div', {
    staticClass: "loader",
    class: {
      'loader-more': _vm.loadOffset
    }
  }, [_vm._v("Loading...")]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.done),
      expression: "done"
    }],
    staticClass: "row"
  }, [(this.whichState === 'none') ? _c('h3', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.done),
      expression: "done"
    }],
    staticClass: "map-header",
    class: {
      'loader-more': _vm.loadOffset
    }
  }, [_vm._v("The Water of the West")]) : _c('h3', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.done),
      expression: "done"
    }],
    staticClass: "map-header",
    class: {
      'map-header-lower': _vm.loadOffset
    }
  }, [_vm._v("The Water of the West - " + _vm._s(_vm.fullState))]), _vm._v(" "), _c('p', {
    staticClass: "offset-sm-1 col-sm-10 offset-lg-1 col-lg-10 text-top"
  }, [_vm._v("\n      The western landscape is varied running from desert to rain forest.\n      However, most of the region tends towards aridness, requiring concentrated reservoirs and irrigation\n      to allow for large scale human settlement. The map and graph below shows the network of reservoirs across\n      the west.")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-lg-6 map-graph"
  }, [_c('h3', [_vm._v("Reservoirs")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Percent Full for Month Ending (" + _vm._s(_vm.dateListing) + "), or Most Recently Available Month")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "map_legend"
    }
  }, [_c('svg', {
    attrs: {
      "width": "450",
      "height": "45",
      "transform": "translate(70,0)"
    }
  }, [_c('g', [_c('rect', {
    staticStyle: {
      "fill": "rgb(26, 150, 65)"
    },
    attrs: {
      "x": "30",
      "y": "15",
      "width": "10",
      "height": "10"
    }
  }), _vm._v(" "), _c('text', {
    attrs: {
      "x": "45",
      "y": "25",
      "height": "30",
      "width": "20"
    }
  }, [_vm._v("75%+")])]), _vm._v(" "), _c('g', [_c('rect', {
    staticStyle: {
      "fill": "rgb(252, 232, 131)"
    },
    attrs: {
      "x": "100",
      "y": "15",
      "width": "10",
      "height": "10"
    }
  }), _vm._v(" "), _c('text', {
    attrs: {
      "x": "115",
      "y": "25",
      "height": "30",
      "width": "20"
    }
  }, [_vm._v("50%+")])]), _vm._v(" "), _c('g', [_c('rect', {
    staticStyle: {
      "fill": "rgb(215, 25, 28)"
    },
    attrs: {
      "x": "165",
      "y": "15",
      "width": "10",
      "height": "10"
    }
  }), _vm._v(" "), _c('text', {
    attrs: {
      "x": "180",
      "y": "25",
      "height": "30",
      "width": "40"
    }
  }, [_vm._v("Less than 50%")])])])]), _vm._v(" "), _c('h4', {
    staticClass: "text-center upper"
  }, [_vm._v("Reservoir Capacity (acre feet)")]), _vm._v(" "), _c('circle-legend-chart', {
    attrs: {
      "dataValues": _vm.stations,
      "field": _vm.legend_field,
      "whichType": _vm.whichType
    }
  }), _vm._v(" "), _c('svg', {
    staticClass: "is-map",
    attrs: {
      "id": "map",
      "width": _vm.width,
      "height": _vm.height,
      "transform": _vm.offset
    }
  }, [_c('g', [_vm._l((_vm.stations), function(d, index) {
    return [_c('circle', {
      attrs: {
        "id": _vm.whichType + d.state + index,
        "cx": _vm.projection([d.lng, d.lat])[0],
        "cy": _vm.projection([d.lng, d.lat])[1],
        "fill": d.color,
        "r": _vm.scale(d.capacity)
      },
      on: {
        "click": function($event) {
          _vm.newRes(d)
        },
        "mouseover": function($event) {
          _vm.showItem(d, _vm.tipDiv, $event)
        },
        "mouseout": function($event) {
          _vm.hideItem(d, _vm.tipDiv, $event)
        },
        "touchstart": function($event) {
          _vm.showItem(d, _vm.tipDiv, $event)
        },
        "touchend": function($event) {
          _vm.hideItem(d, _vm.tipDiv, $event)
        }
      }
    })]
  })], 2)])], 1), _vm._v(" "), _c('line-chart', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.done),
      expression: "done"
    }],
    attrs: {
      "whichState": _vm.whichState,
      "reservoirName": _vm.reservoirName,
      "selectedData": _vm.selectedData,
      "hasKey": _vm.hasKey
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "offset-sm-1 col-sm-10 offset-lg-1 col-lg-10 text-top text-next"
  }, [_vm._v("\n        Much of the American West has been in and out of drought for most of the 21"), _c('sup', [_vm._v("st")]), _vm._v(" century; leading\n      to lower average water levels than would be typical. For an example, check out reservoir levels in California\n      in 2015 and most of 2016.\n      Click a reservoir to display its levels. Hover over the graph to see the levels for a given month. Data\n        updated monthly; so feel free to check back often.")])
}]}

/***/ }),
/* 382 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('arizona-map', {
    attrs: {
      "mapFile": "az.counties.json",
      "dataFile": "az_load.csv",
      "res": "Lake Havasu",
      "resFile": "az.json",
      "whichState": "AZ"
    }
  }), _vm._v(" "), _c('snow-chart', {
    attrs: {
      "whichState": "AZ"
    }
  }), _vm._v(" "), _c('drought-map', {
    attrs: {
      "mapFile": "az.counties.json",
      "centersFile": "az_centers.json",
      "dataFile": "az-counties.csv"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 383 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12 col-lg-12"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.done),
      expression: "done"
    }]
  }, [_c('h3', [_vm._v("Snow Levels")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('h4', {
    staticClass: "text-center"
  }, [_vm._v("Temperature (degrees Fahrenheit)")])]), _vm._v(" "), _c('legend-chart', {
    attrs: {
      "colors": _vm.colors,
      "dataValues": _vm.dataValues,
      "field": _vm.legend_temp
    }
  }), _vm._v(" "), _c('h4', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.done),
      expression: "done"
    }],
    staticClass: "text-center"
  }, [_vm._v("Snow/Water Equivalence (inches)")]), _vm._v(" "), _c('circle-legend-chart', {
    attrs: {
      "dataValues": _vm.dataValues,
      "field": _vm.legend_snow,
      "whichType": _vm.whichType
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.done),
      expression: "done"
    }],
    attrs: {
      "id": "snow_graph"
    }
  }, [_c('svg', {
    attrs: {
      "id": "snow",
      "height": _vm.graph_height,
      "width": _vm.graph_width
    }
  }, [_c('g', {
    staticClass: "axis x",
    attrs: {
      "transform": _vm.graph_translate
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "axis y",
    attrs: {
      "transform": _vm.graph_translate_left
    }
  }), _vm._v(" "), _vm._l((_vm.snow_data), function(d, index) {
    return [_c('circle', {
      attrs: {
        "id": _vm.whichType + d.state + index,
        "cx": _vm.xYearScale(d.date),
        "cy": _vm.elevationScale(d.elev),
        "r": _vm.circleSize(d.snow_mean),
        "fill": _vm.color(d.temp_mean),
        "transform": _vm.graph_translate
      },
      on: {
        "mouseover": function($event) {
          _vm.showItem(d, _vm.tipDiv, $event)
        },
        "mouseout": function($event) {
          _vm.hideItem(d, _vm.tipDiv, $event)
        },
        "touchstart": function($event) {
          _vm.showItem(d, _vm.tipDiv, $event)
        },
        "touchend": function($event) {
          _vm.hideItem(d, _vm.tipDiv, $event)
        }
      }
    })]
  })], 2)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "offset-sm-1 col-sm-10 offset-lg-1 col-lg-10 text-top-palmer"
  }, [_c('p', [_vm._v("Snow is vital to the environmental health of the western United States. Unlike rainfall, it doesn't\n        come as one burst that's here and then quickly gone. Instead, it tends to accrue over the winter and slowly\n        melt as the temperatures rise in the spring. The melt typically continues into the early summer, providing\n        a steady, consistent level of water in mountain watersheds. This is particularly important for a\n        state like California, which receives almost no summer rainfall.")]), _vm._v(" "), _c('p', [_vm._v("Snow comes in a variety of forms. It can be light and airy, almost dry, or it can heavy and dense. For example,\n        light, fluffy snow that measures four feet deep might actually have the\n        same volume of water as heavier, denser snow that is two feet deep.To account\n        for this variation a measure called\n        "), _c('a', {
    staticClass: "inside",
    attrs: {
      "href": "http://www.nrcs.usda.gov/wps/portal/nrcs/detail/or/snow/?cid=nrcs142p2_046155",
      "target": "_blank"
    }
  }, [_vm._v("snow water equivalence")]), _vm._v(" is used to normalize the amount of liquid water\n        in a given level of snow. The graph below uses "), _c('a', {
    staticClass: "inside",
    attrs: {
      "href": "https://www.wcc.nrcs.usda.gov/snow"
    }
  }, [_vm._v("SNOTEL")]), _vm._v("\n        data; a series of automated weather stations distributed across the west to\n        measure things such as snow levels and temperature. Notice how temperature and snow levels change with elevation.\n        Compare the average snow/water levels by year and elevation. The general trend is towards drier\n        conditions, but wet years are interspersed with drier years.")])])
}]}

/***/ }),
/* 384 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('idaho-map', {
    attrs: {
      "mapFile": "id.counties.json",
      "dataFile": "id_load.csv",
      "res": "Arrowrock",
      "resFile": "id.json",
      "whichState": "ID"
    }
  }), _vm._v(" "), _c('snow-chart', {
    attrs: {
      "whichState": "ID"
    }
  }), _vm._v(" "), _c('drought-map', {
    attrs: {
      "mapFile": "id.counties.json",
      "centersFile": "id_centers.json",
      "dataFile": "id-counties.csv"
    }
  })], 1)
},staticRenderFns: []}

/***/ })
],[230]);


// WEBPACK FOOTER //
// static/js/app.ab93471359b2a074889f.js